import * as React from 'react';
import React__default, { memo, forwardRef, useMemo } from 'react';
import styled from 'styled-components';
import { layout } from 'styled-system';

var _path$2L;

function _extends$2U() { _extends$2U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2U.apply(this, arguments); }

function SvgOnlinetestSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2U({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2L || (_path$2L = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.923 17H21.5c.275 0 .5.225.5.5v.5c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-.5c0-.275.225-.5.5-.5h7.476c-.008.454.44 1 1.024 1h1.9c.563 0 1-.38 1.023-1zM18.5 4c.825 0 1.5.675 1.5 1.5V16H4V5.5C4 4.675 4.675 4 5.5 4h13zm-7.197 9.113l4.582-4.544a.385.385 0 00.004-.544l-.904-.91a.385.385 0 00-.545-.004l-3.396 3.372-1.475-1.487a.385.385 0 00-.544-.004l-.91.904a.385.385 0 00-.004.545l2.647 2.67c.15.15.394.153.545.002z",
    fill: "#000"
  })));
}

var _path$2K;

function _extends$2T() { _extends$2T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2T.apply(this, arguments); }

function SvgAddressBookSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2T({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2K || (_path$2K = /*#__PURE__*/React.createElement("path", {
    d: "M20.281 8.25a.47.47 0 00.469-.469V6.22a.47.47 0 00-.469-.469H19.5V3.875C19.5 2.84 18.66 2 17.625 2h-12.5C4.09 2 3.25 2.84 3.25 3.875v16.25C3.25 21.16 4.09 22 5.125 22h12.5c1.035 0 1.875-.84 1.875-1.875V18.25h.781a.47.47 0 00.469-.469V16.22a.47.47 0 00-.469-.469H19.5v-2.5h.781a.47.47 0 00.469-.469V11.22a.47.47 0 00-.469-.469H19.5v-2.5h.781zM11.375 7c1.379 0 2.5 1.121 2.5 2.5s-1.121 2.5-2.5 2.5a2.502 2.502 0 01-2.5-2.5c0-1.379 1.121-2.5 2.5-2.5zm4.375 9.25c0 .414-.39.75-.875.75h-7C7.391 17 7 16.664 7 16.25v-.75c0-1.242 1.176-2.25 2.625-2.25h.195a4.032 4.032 0 003.11 0h.195c1.45 0 2.625 1.008 2.625 2.25v.75z",
    fill: "#000"
  })));
}

var _path$2J;

function _extends$2S() { _extends$2S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2S.apply(this, arguments); }

function SvgAddressCardSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2S({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2J || (_path$2J = /*#__PURE__*/React.createElement("path", {
    d: "M20.333 4.222H3.667C2.747 4.222 2 4.97 2 5.89V18.11c0 .92.747 1.667 1.667 1.667h16.666c.92 0 1.667-.747 1.667-1.667V5.89c0-.92-.747-1.667-1.667-1.667zM8.111 7.555c1.226 0 2.222.997 2.222 2.223A2.224 2.224 0 018.111 12 2.224 2.224 0 015.89 9.778c0-1.226.996-2.223 2.222-2.223zM12 15.779c0 .368-.347.666-.778.666H5c-.43 0-.778-.298-.778-.666v-.667c0-1.104 1.045-2 2.334-2h.173a3.585 3.585 0 002.764 0h.174c1.288 0 2.333.896 2.333 2v.667zm7.778-1.834a.279.279 0 01-.278.278h-5a.279.279 0 01-.278-.278v-.555c0-.153.125-.278.278-.278h5c.153 0 .278.125.278.278v.555zm0-2.222A.279.279 0 0119.5 12h-5a.279.279 0 01-.278-.278v-.555c0-.153.125-.278.278-.278h5c.153 0 .278.125.278.278v.555zm0-2.222a.279.279 0 01-.278.278h-5a.279.279 0 01-.278-.278v-.556c0-.152.125-.277.278-.277h5c.153 0 .278.125.278.277V9.5z",
    fill: "#000"
  })));
}

var _path$2I;

function _extends$2R() { _extends$2R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2R.apply(this, arguments); }

function SvgAlbumSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2R({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2I || (_path$2I = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.222 3a2 2 0 00-2 2v1.333H2.5a.5.5 0 00-.5.5v1.223a.5.5 0 00.5.5h1.722v2.222H2.5a.5.5 0 00-.5.5V12.5a.5.5 0 00.5.5h1.722v2.222H2.5a.5.5 0 00-.5.5v1.222a.5.5 0 00.5.5h1.722v1.334a2 2 0 002 2H20a2 2 0 002-2V5a2 2 0 00-2-2H6.222zM12.5 9a2 2 0 11-4 0 2 2 0 014 0zm-4.625 5.2L9.5 12.9a1 1 0 011.072-.114l1.737.869a1 1 0 001.2-.236l2.216-2.533a1 1 0 011.524.022l2.022 2.451a1 1 0 01.229.637V17a1 1 0 01-1 1h-10a1 1 0 01-1-1v-2.02a1 1 0 01.375-.78z",
    fill: "#000"
  })));
}

var _path$2H;

function _extends$2Q() { _extends$2Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2Q.apply(this, arguments); }

function SvgAngleLeftSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2Q({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2H || (_path$2H = /*#__PURE__*/React.createElement("path", {
    d: "M5.983 10.938L14.48 2.44a1.493 1.493 0 012.118 0l1.412 1.413a1.493 1.493 0 010 2.118L11.993 12l6.024 6.023a1.493 1.493 0 010 2.118l-1.413 1.419a1.493 1.493 0 01-2.118 0L5.99 13.062a1.495 1.495 0 01-.006-2.124z",
    fill: "#000"
  })));
}

var _path$2G;

function _extends$2P() { _extends$2P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2P.apply(this, arguments); }

function SvgAngleRightSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2P({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2G || (_path$2G = /*#__PURE__*/React.createElement("path", {
    d: "M18.014 13.062L9.517 21.56a1.493 1.493 0 01-2.118 0l-1.412-1.412a1.493 1.493 0 010-2.119l6.023-6.023-6.023-6.023a1.493 1.493 0 010-2.118L7.392 2.44a1.493 1.493 0 012.119 0l8.497 8.498c.593.587.593 1.537.006 2.124z",
    fill: "#000"
  })));
}

var _path$2F;

function _extends$2O() { _extends$2O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2O.apply(this, arguments); }

function SvgArrowLeftOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2O({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2F || (_path$2F = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.168c0 .294.113.565.34.78l7.07 7.059c.248.237.497.34.769.34.577 0 1.018-.42 1.018-.996a.98.98 0 00-.294-.724l-2.398-2.444-3.428-3.133 2.545.158h13.349c.6 0 1.029-.43 1.029-1.04 0-.6-.43-1.03-1.03-1.03H7.623l-2.556.158 3.439-3.133 2.398-2.444c.18-.18.294-.44.294-.723 0-.577-.441-.996-1.018-.996-.272 0-.51.102-.747.317L2.34 11.398c-.226.215-.339.487-.339.77z",
    fill: "#000"
  })));
}

var _path$2E;

function _extends$2N() { _extends$2N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2N.apply(this, arguments); }

function SvgArrowRightOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2N({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2E || (_path$2E = /*#__PURE__*/React.createElement("path", {
    d: "M22 12.179c0-.294-.113-.566-.34-.78l-7.07-7.06c-.248-.237-.497-.339-.769-.339-.577 0-1.018.419-1.018.995a.98.98 0 00.294.724l2.399 2.444 3.427 3.133-2.545-.158H3.029c-.6 0-1.029.43-1.029 1.04 0 .6.43 1.03 1.03 1.03h13.348l2.556-.158-3.439 3.133-2.398 2.444a1.026 1.026 0 00-.294.724c0 .577.441.995 1.018.995.272 0 .51-.102.747-.317l7.093-7.081c.226-.215.339-.487.339-.77z",
    fill: "#000"
  })));
}

var _path$2D;

function _extends$2M() { _extends$2M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2M.apply(this, arguments); }

function SvgArrowSquareUpSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2M({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2D || (_path$2D = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 17.857V6.143C22 4.96 21.04 4 19.857 4H4.143C2.96 4 2 4.96 2 6.143v11.714C2 19.04 2.96 20 4.143 20h15.714C21.04 20 22 19.04 22 17.857zM8.13 12.212l.406.407a.437.437 0 00.628-.007l2.104-2.208v5.266c0 .244.196.44.44.44h.586c.244 0 .44-.196.44-.44v-5.266l2.101 2.206a.44.44 0 00.629.007l.407-.406a.438.438 0 000-.622l-3.56-3.56a.438.438 0 00-.622 0l-3.56 3.562a.438.438 0 000 .621z",
    fill: "#000"
  })));
}

var _path$2C, _path2$k;

function _extends$2L() { _extends$2L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2L.apply(this, arguments); }

function SvgBackToListSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2L({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2C || (_path$2C = /*#__PURE__*/React.createElement("path", {
    d: "M7.111 6.227s.2-.4-.2-.4H3.508s-1.502-.1-1.502 1.301V19.04s-.2 1.502 1.702 1.502H16.22s1.302-.1 1.302-1.502v-4.905s-.2-.5-.701-.7c0 0-.7-.3-.7.7v4.905H3.406V7.328H5.91s.2 0 .4-.2l.801-.9z",
    fill: "#000"
  })), _path2$k || (_path2$k = /*#__PURE__*/React.createElement("path", {
    d: "M12.817 4.926v2.402s6.607-.4 8.509 3.103c0 0 1.701 3.003-.3 6.107 0 0-1.302 2.302-2.303 1.901 0 0-.3-.2-.3-.7 0 0 .5-1.502.4-2.603 0 0 .6-3.503-6.206-3.303v2.602s-.1 1.001-1.302.5L6.31 10.132s-.7-.6 0-1.401l4.905-4.605c.2.1 1.402-.7 1.602.8z",
    fill: "#000"
  })));
}

var _path$2B, _path2$j;

function _extends$2K() { _extends$2K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2K.apply(this, arguments); }

function SvgBackstageManagementSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2K({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2B || (_path$2B = /*#__PURE__*/React.createElement("path", {
    d: "M21.9 15.9l-.8-.4c0-.2.1-.4.1-.6 0-.2 0-.5-.1-.7l.8-.4s.3-.1-.3-1.2c-.7-1.1-.9-.9-.9-.9l-.8.3c-.3-.3-.7-.5-1.1-.6v-1s.1-.3-1.2-.3-1.2.3-1.2.3v1c-.4.1-.7.4-1.1.6l-.9-.5s-.2-.2-.9.9c-.6 1.1-.3 1.2-.3 1.2l.9.5c0 .2-.1.4-.1.6v.6l-.9.5s-.3.1.3 1.2c.7 1.1.9.9.9.9l.9-.5c.3.3.7.5 1.1.7v.9s-.1.3 1.2.3 1.2-.3 1.2-.3v-.9c.4-.1.8-.4 1.1-.7l.8.5s.2.2.9-.9c.8-1 .4-1.1.4-1.1zm-4.3.4c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5z",
    fill: "#000"
  })), _path2$j || (_path2$j = /*#__PURE__*/React.createElement("path", {
    d: "M15.3 18.9c-.2.1-1.4 1-2.6-1.2-.9-1.6-.4-2.4 0-2.7H4.2V5.2h15.3v4.4c.5.3.5.8.5 1 0 0 .8-.7 1.8.1v-6C21.7 3.8 21 3 20 3H3.7C2.8 3 2 3.8 2 4.7v10.9c0 .9.8 1.7 1.7 1.7h6.6L9.7 19H7.2c-.4 0-.8.4-.8.8s.4.8.8.8h9.3c.1 0 .2 0 .3-.1-1.5-.3-1.5-1.3-1.5-1.6z",
    fill: "#000"
  })));
}

var _circle$4, _path$2A;

function _extends$2J() { _extends$2J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2J.apply(this, arguments); }

function SvgBanSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2J({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$4 || (_circle$4 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    stroke: "#000",
    strokeWidth: 2
  })), _path$2A || (_path$2A = /*#__PURE__*/React.createElement("path", {
    d: "M5 5l13.5 13.5",
    stroke: "#000",
    strokeWidth: 2
  })));
}

var _circle$3, _path$2z;

function _extends$2I() { _extends$2I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2I.apply(this, arguments); }

function SvgBanSolidGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2I({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$3 || (_circle$3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    stroke: "#8A94A6",
    strokeWidth: 2
  })), _path$2z || (_path$2z = /*#__PURE__*/React.createElement("path", {
    d: "M5 5l13.5 13.5",
    stroke: "#8A94A6",
    strokeWidth: 2
  })));
}

var _path$2y;

function _extends$2H() { _extends$2H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2H.apply(this, arguments); }

function SvgBarsSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2H({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2y || (_path$2y = /*#__PURE__*/React.createElement("path", {
    d: "M2.714 6.464h18.572c.394 0 .714-.32.714-.714V3.964a.714.714 0 00-.714-.714H2.714A.714.714 0 002 3.964V5.75c0 .395.32.714.714.714zm0 7.143h18.572c.394 0 .714-.32.714-.714v-1.786a.714.714 0 00-.714-.714H2.714a.714.714 0 00-.714.714v1.786c0 .394.32.714.714.714zm0 7.143h18.572c.394 0 .714-.32.714-.714V18.25a.714.714 0 00-.714-.714H2.714A.714.714 0 002 18.25v1.786c0 .394.32.714.714.714z",
    fill: "#000"
  })));
}

var _path$2x;

function _extends$2G() { _extends$2G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2G.apply(this, arguments); }

function SvgBoldSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2G({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2x || (_path$2x = /*#__PURE__*/React.createElement("path", {
    d: "M17.893 11.196c.68-.83 1.099-1.843 1.205-2.91C19.428 4.878 16.755 2 13.425 2H4.523a.714.714 0 00-.715.714v2.143a.714.714 0 00.715.714h1.423V18.43H4.523a.714.714 0 00-.715.714v2.143a.714.714 0 00.715.714h9.344c3.161 0 5.989-2.31 6.295-5.464.212-2.163-.732-4.11-2.27-5.34zM9.508 5.571h3.917a2.143 2.143 0 110 4.286H9.508V5.571zm3.917 12.858H9.508v-5h3.917a2.5 2.5 0 110 5z",
    fill: "#000"
  })));
}

var _path$2w;

function _extends$2F() { _extends$2F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2F.apply(this, arguments); }

function SvgBookReaderSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2F({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2w || (_path$2w = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 5.75a3.75 3.75 0 10-7.5 0 3.75 3.75 0 007.5 0zm-4.626 5.668c-2.317-1.419-6.07-1.809-7.96-1.916C2.529 9.466 2 9.95 2 10.56v8.703c0 .56.453 1.027 1.035 1.057 1.705.09 5.155.417 7.54 1.618.366.184.8-.067.8-.464v-9.608a.52.52 0 00-.25-.448zm9.712-1.916c-1.89.107-5.643.497-7.96 1.916a.53.53 0 00-.25.454v9.601c0 .398.434.65.802.465 2.384-1.2 5.832-1.528 7.537-1.617.582-.03 1.035-.497 1.035-1.057V10.56c0-.61-.53-1.094-1.164-1.058z",
    fill: "#000"
  })));
}

var _path$2v;

function _extends$2E() { _extends$2E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2E.apply(this, arguments); }

function SvgBookSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2E({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2v || (_path$2v = /*#__PURE__*/React.createElement("path", {
    d: "M20.85 4.002c-1.912.104-5.703.487-8.033 1.913a.543.543 0 00-.279.452v12.66c0 .417.453.66.835.487 2.4-1.218 5.878-1.566 7.582-1.635.591-.035 1.044-.522 1.044-1.078V5.045c.034-.591-.522-1.078-1.148-1.043zm-9.668 1.913C8.852 4.489 5.06 4.106 3.148 4.002 2.522 3.967 2 4.454 2 5.045v11.756c0 .556.452 1.043 1.043 1.078 1.705.07 5.183.417 7.582 1.635.383.174.835-.07.835-.487V6.367a.543.543 0 00-.278-.452z",
    fill: "#000"
  })));
}

var _path$2u;

function _extends$2D() { _extends$2D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2D.apply(this, arguments); }

function SvgBookmarkSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2D({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2u || (_path$2u = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 22V3.875C4.5 2.839 5.34 2 6.375 2h11.25c1.035 0 1.875.84 1.875 1.875V22L12 17.625 4.5 22z",
    fill: "#000"
  })));
}

var _path$2t;

function _extends$2C() { _extends$2C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2C.apply(this, arguments); }

function SvgBooksSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2C({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2t || (_path$2t = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 16.063V2.938A.935.935 0 0019.812 2H7C4.93 2 3.25 3.68 3.25 5.75v12.5C3.25 20.32 4.93 22 7 22h12.813c.519 0 .937-.418.937-.938v-.625a.945.945 0 00-.348-.73c-.164-.602-.164-2.316 0-2.918a.93.93 0 00.348-.727zM8.25 7.233c0-.129.105-.234.234-.234h8.282c.129 0 .234.105.234.234v.782a.235.235 0 01-.234.234H8.484a.235.235 0 01-.234-.234v-.782zm0 2.5c0-.129.105-.234.234-.234h8.282c.129 0 .234.105.234.234v.782a.235.235 0 01-.234.234H8.484a.235.235 0 01-.234-.234v-.782zm9.898 9.766H7c-.691 0-1.25-.559-1.25-1.25 0-.688.563-1.25 1.25-1.25h11.148a14.066 14.066 0 000 2.5z",
    fill: "#000"
  })));
}

var _path$2s;

function _extends$2B() { _extends$2B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2B.apply(this, arguments); }

function SvgBoxOpenSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2B({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2s || (_path$2s = /*#__PURE__*/React.createElement("path", {
    d: "M15.304 12.001a1.515 1.515 0 01-1.294-.731L12 7.939l-2.005 3.33a1.52 1.52 0 01-1.297.735c-.14 0-.281-.019-.416-.06l-4.28-1.224v5.562c0 .46.312.86.755.969l6.756 1.69c.319.078.653.078.969 0l6.762-1.69c.444-.113.756-.513.756-.97V10.72l-4.28 1.222c-.135.04-.276.059-.416.059zm6.643-3.506l-1.61-3.212a.51.51 0 00-.521-.278L12 6l2.865 4.753c.119.197.356.29.578.228l6.184-1.765c.31-.09.46-.435.319-.722zM3.664 5.283l-1.61 3.212a.51.51 0 00.316.719l6.184 1.765a.514.514 0 00.578-.228l2.869-4.75-7.819-.996a.51.51 0 00-.518.278z",
    fill: "#000"
  })));
}

var _path$2r;

function _extends$2A() { _extends$2A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2A.apply(this, arguments); }

function SvgBrowserSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2A({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2r || (_path$2r = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5.25a2 2 0 012-2h16a2 2 0 012 2v13.5a2 2 0 01-2 2H4a2 2 0 01-2-2V5.25zm2.5 1a.5.5 0 01.5-.5h1.5a.5.5 0 01.5.5v1.5a.5.5 0 01-.5.5H5a.5.5 0 01-.5-.5v-1.5zm4.5-.5a.5.5 0 00-.5.5v1.5a.5.5 0 00.5.5h10a.5.5 0 00.5-.5v-1.5a.5.5 0 00-.5-.5H9z",
    fill: "#000"
  })));
}

var _path$2q;

function _extends$2z() { _extends$2z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2z.apply(this, arguments); }

function SvgBullhornSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2z({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2q || (_path$2q = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 11.333c0-.82-.45-1.529-1.111-1.914V4.111c0-.303-.242-1.111-1.111-1.111-.247 0-.493.083-.694.244l-2.952 2.362A8.433 8.433 0 0112 7.37v7.927a8.432 8.432 0 014.131 1.764l2.953 2.362c.197.158.441.243.693.244.866 0 1.111-.791 1.111-1.111v-5.308A2.213 2.213 0 0022 11.333zm-11 3.89H9.914a4.202 4.202 0 00-.153 1.11c0 1.01.338 1.942.908 2.69.548.719.005 1.755-.9 1.755H7.19c-.412 0-.806-.221-.986-.593a8.796 8.796 0 01-.887-3.852c0-.377.027-.747.075-1.11h-1.17A2.222 2.222 0 012 13V9.667c0-1.228.995-2.223 2.222-2.223H11v7.779z",
    fill: "#000"
  })));
}

var _path$2p;

function _extends$2y() { _extends$2y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2y.apply(this, arguments); }

function SvgCalenderTodaySolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2y({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2p || (_path$2p = /*#__PURE__*/React.createElement("path", {
    d: "M4 19.313C4 20.262 4.738 21 5.688 21h12.375c.914 0 1.687-.738 1.687-1.688V9.75H4v9.563zm2.25-6.75c0-.282.246-.563.563-.563h3.375c.28 0 .562.281.562.563v3.374a.578.578 0 01-.563.563H6.813a.555.555 0 01-.563-.563v-3.374zM18.063 5.25h-1.688V3.562c0-.28-.281-.562-.563-.562h-1.124a.578.578 0 00-.563.563V5.25h-4.5V3.562c0-.28-.281-.562-.563-.562H7.938a.578.578 0 00-.563.563V5.25H5.687C4.739 5.25 4 6.023 4 6.938v1.687h15.75V6.937c0-.914-.773-1.687-1.688-1.687z",
    fill: "#000"
  })));
}

var _path$2o;

function _extends$2x() { _extends$2x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2x.apply(this, arguments); }

function SvgCameraSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2x({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2o || (_path$2o = /*#__PURE__*/React.createElement("path", {
    d: "M22 7.625v11.25c0 1.035-.84 1.875-1.875 1.875H3.875A1.875 1.875 0 012 18.875V7.625C2 6.59 2.84 5.75 3.875 5.75h3.438l.48-1.285A1.872 1.872 0 019.547 3.25h4.902c.781 0 1.48.484 1.754 1.215l.485 1.285h3.437C21.16 5.75 22 6.59 22 7.625zm-5.313 5.625A4.691 4.691 0 0012 8.562a4.691 4.691 0 00-4.688 4.688A4.691 4.691 0 0012 17.938a4.691 4.691 0 004.688-4.688zm-1.25 0A3.443 3.443 0 0112 16.688a3.443 3.443 0 01-3.438-3.438A3.443 3.443 0 0112 9.812a3.443 3.443 0 013.438 3.438z",
    fill: "#000"
  })));
}

var _path$2n;

function _extends$2w() { _extends$2w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2w.apply(this, arguments); }

function SvgCaretDownSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2w({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2n || (_path$2n = /*#__PURE__*/React.createElement("path", {
    d: "M3.346 6.328h17.308c1.198 0 1.796 1.446.949 2.293l-8.651 8.658a1.348 1.348 0 01-1.904 0l-8.65-8.658c-.848-.847-.25-2.293.948-2.293z",
    fill: "#000"
  })));
}

var _path$2m;

function _extends$2v() { _extends$2v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2v.apply(this, arguments); }

function SvgCaretLeftSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2v({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2m || (_path$2m = /*#__PURE__*/React.createElement("path", {
    d: "M17.671 3.348v17.304c0 1.199-1.449 1.799-2.296.951l-8.652-8.652a1.345 1.345 0 010-1.902l8.652-8.652c.847-.848 2.296-.248 2.296.95z",
    fill: "#000"
  })));
}

var _path$2l;

function _extends$2u() { _extends$2u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2u.apply(this, arguments); }

function SvgCaretRightSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2u({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2l || (_path$2l = /*#__PURE__*/React.createElement("path", {
    d: "M6.329 20.652V3.348c0-1.199 1.449-1.799 2.296-.951l8.652 8.652a1.345 1.345 0 010 1.902l-8.652 8.652c-.847.848-2.296.248-2.296-.95z",
    fill: "#000"
  })));
}

var _path$2k;

function _extends$2t() { _extends$2t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2t.apply(this, arguments); }

function SvgCaretUpSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2t({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2k || (_path$2k = /*#__PURE__*/React.createElement("path", {
    d: "M20.652 17.671H3.348c-1.199 0-1.799-1.449-.951-2.296l8.652-8.652a1.345 1.345 0 011.902 0l8.652 8.652c.848.847.248 2.296-.95 2.296z",
    fill: "#000"
  })));
}

var _path$2j;

function _extends$2s() { _extends$2s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2s.apply(this, arguments); }

function SvgChalkboardOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2s({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2j || (_path$2j = /*#__PURE__*/React.createElement("path", {
    d: "M5 6h14v11h2V5.25C21 4.56 20.44 4 19.75 4H4.25C3.56 4 3 4.56 3 5.25V17h2V6zm16.5 12H17v-2h-6v2H2.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h19a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5z",
    fill: "#000"
  })));
}

var _path$2i, _path2$i;

function _extends$2r() { _extends$2r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2r.apply(this, arguments); }

function SvgChalkboardSlashSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2r({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2i || (_path$2i = /*#__PURE__*/React.createElement("path", {
    d: "M20.638 18.895L2.252 4.685a.5.5 0 01-.088-.702l.614-.79a.5.5 0 01.702-.088l18.386 14.21a.5.5 0 01.088.702l-.614.79a.5.5 0 01-.702.088z",
    fill: "#B0B7C3"
  })), _path2$i || (_path2$i = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.27 19.4l-4.658-3.6H11.1v1.8H3.45a.45.45 0 00-.45.45v.9c0 .249.201.45.45.45h14.82zm.942-1.8l1.595 1.233a.498.498 0 01.172.252.448.448 0 00.021-.135v-.9a.45.45 0 00-.45-.45h-1.338zM5.7 7.157V6.8h12.6v9.9h1.8V6.125c0-.62-.505-1.125-1.125-1.125H5.025c-.508 0-.939.339-1.078.802L5.7 7.157zM3.9 8.294l1.8 1.391V16.7H3.9V8.294z",
    fill: "#B0B7C3"
  })));
}

var _rect$4, _path$2h;

function _extends$2q() { _extends$2q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2q.apply(this, arguments); }

function SvgChalkboardSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2q({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$4 || (_rect$4 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 18,
    width: 20,
    height: 2,
    rx: 1,
    fill: "#000"
  })), _path$2h || (_path$2h = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4a1 1 0 00-1 1v11a1 1 0 001 1h10v-2.5a.5.5 0 01.5-.5h4a.5.5 0 01.5.5V17h1a1 1 0 001-1V5a1 1 0 00-1-1H4z",
    fill: "#000"
  })));
}

var _path$2g;

function _extends$2p() { _extends$2p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2p.apply(this, arguments); }

function SvgCheckCircleSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2p({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2g || (_path$2g = /*#__PURE__*/React.createElement("path", {
    d: "M12.005 21.99c5.467 0 9.995-4.528 9.995-9.995S17.462 2 11.995 2C6.528 2 2 6.528 2 11.995s4.538 9.995 10.005 9.995zm-1.104-5.21c-.35 0-.629-.144-.887-.484l-2.434-2.97a1.102 1.102 0 01-.237-.66c0-.465.35-.836.825-.836.279 0 .506.093.753.412l1.94 2.496 4.125-6.6c.186-.32.454-.475.732-.475.444 0 .857.31.857.784 0 .216-.114.453-.248.66l-4.58 7.179c-.206.33-.495.495-.845.495z",
    fill: "#000"
  })));
}

var _path$2f;

function _extends$2o() { _extends$2o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2o.apply(this, arguments); }

function SvgCheckSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2o({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2f || (_path$2f = /*#__PURE__*/React.createElement("path", {
    d: "M8.793 19.164l-6.5-6.5a1 1 0 010-1.414l1.414-1.414a1 1 0 011.414 0L9.5 14.214l9.379-9.378a1 1 0 011.414 0l1.414 1.414a1 1 0 010 1.414l-11.5 11.5a1 1 0 01-1.414 0z",
    fill: "#000"
  })));
}

var _path$2e;

function _extends$2n() { _extends$2n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2n.apply(this, arguments); }

function SvgChevronDownOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2n({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2e || (_path$2e = /*#__PURE__*/React.createElement("path", {
    d: "M12.006 17.347c.326 0 .628-.145.858-.386l8.798-9.003c.217-.218.338-.496.338-.81C22 6.495 21.505 6 20.852 6c-.302 0-.604.12-.822.338l-8.024 8.218L3.97 6.338A1.13 1.13 0 003.148 6C2.508 6 2 6.495 2 7.148c0 .314.12.592.338.81l8.798 9.003c.254.254.532.386.87.386z",
    fill: "#000"
  })));
}

var _path$2d, _path2$h;

function _extends$2m() { _extends$2m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2m.apply(this, arguments); }

function SvgChevronDownToBottomSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2m({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2d || (_path$2d = /*#__PURE__*/React.createElement("path", {
    d: "M12.006 15.347c.326 0 .628-.145.858-.386l8.798-9.003c.217-.218.338-.496.338-.81C22 4.495 21.505 4 20.852 4c-.302 0-.604.12-.822.338l-8.024 8.218L3.97 4.338A1.13 1.13 0 003.148 4C2.508 4 2 4.495 2 5.148c0 .314.12.592.338.81l8.798 9.003c.254.253.532.386.87.386z",
    fill: "#000"
  })), _path2$h || (_path2$h = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 18.125c0 .621-.504 1.125-1.125 1.125H3.125a1.125 1.125 0 010-2.25h17.75c.621 0 1.125.504 1.125 1.125z",
    fill: "#000"
  })));
}

var _path$2c;

function _extends$2l() { _extends$2l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2l.apply(this, arguments); }

function SvgChevronLeftOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2l({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2c || (_path$2c = /*#__PURE__*/React.createElement("path", {
    d: "M6 12c0 .395.147.733.462 1.026l8.771 8.59c.248.249.564.384.936.384a1.33 1.33 0 001.342-1.342c0-.372-.158-.699-.406-.958L9.202 12l7.903-7.7c.248-.26.406-.598.406-.958A1.33 1.33 0 0016.169 2c-.372 0-.688.135-.936.383l-8.77 8.58C6.146 11.267 6 11.605 6 12z",
    fill: "#000"
  })));
}

var _path$2b;

function _extends$2k() { _extends$2k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2k.apply(this, arguments); }

function SvgChevronRightOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2k({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2b || (_path$2b = /*#__PURE__*/React.createElement("path", {
    d: "M18 12c0-.395-.147-.733-.462-1.026l-8.771-8.59A1.284 1.284 0 007.83 2a1.33 1.33 0 00-1.342 1.342c0 .372.158.699.406.958l7.903 7.7-7.903 7.7c-.248.26-.406.598-.406.958A1.33 1.33 0 007.831 22c.372 0 .688-.135.936-.383l8.77-8.58c.316-.304.463-.642.463-1.037z",
    fill: "#000"
  })));
}

var _path$2a;

function _extends$2j() { _extends$2j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2j.apply(this, arguments); }

function SvgChevronUpOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2j({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2a || (_path$2a = /*#__PURE__*/React.createElement("path", {
    d: "M2.338 15.378l8.798-9.003c.242-.242.532-.375.87-.375.326 0 .628.133.858.375l8.798 9.003c.217.217.338.495.338.81 0 .652-.495 1.16-1.148 1.16a1.15 1.15 0 01-.822-.339l-8.024-8.217-8.036 8.217a1.111 1.111 0 01-.822.338c-.64 0-1.148-.507-1.148-1.16 0-.314.12-.604.338-.81z",
    fill: "#000"
  })));
}

var _path$29, _path2$g;

function _extends$2i() { _extends$2i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2i.apply(this, arguments); }

function SvgChevronUpToTopSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2i({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$29 || (_path$29 = /*#__PURE__*/React.createElement("path", {
    d: "M11.994 7.903c-.326 0-.628.145-.858.386l-8.798 9.003a1.123 1.123 0 00-.338.81c0 .652.495 1.148 1.148 1.148.302 0 .604-.12.822-.338l8.024-8.218 8.036 8.218c.218.217.496.338.822.338.64 0 1.148-.495 1.148-1.148 0-.314-.12-.592-.338-.81L12.864 8.29c-.254-.253-.532-.386-.87-.386z",
    fill: "#000"
  })), _path2$g || (_path2$g = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5.125C2 4.504 2.504 4 3.125 4h17.75a1.125 1.125 0 010 2.25H3.125A1.125 1.125 0 012 5.125z",
    fill: "#000"
  })));
}

var _circle$2;

function _extends$2h() { _extends$2h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2h.apply(this, arguments); }

function SvgCircleOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2h({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$2 || (_circle$2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    stroke: "#000",
    strokeWidth: 2
  })));
}

var _path$28;

function _extends$2g() { _extends$2g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2g.apply(this, arguments); }

function SvgClassSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2g({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$28 || (_path$28 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15a2 2 0 100-4 2 2 0 000 4zM6.2 16h-.224a1.86 1.86 0 01-.976.286c-.348 0-.678-.104-.976-.286H3.8C2.806 16 2 17.075 2 18.4v.743c0 .473.288.857.643.857h4.714c.355 0 .643-.384.643-.857V18.4c0-1.325-.806-2.4-1.8-2.4zM12 15a2 2 0 100-4 2 2 0 000 4zM13.2 16h-.224a1.86 1.86 0 01-.976.286c-.348 0-.678-.104-.976-.286H10.8C9.806 16 9 17.075 9 18.4v.743c0 .473.288.857.643.857h4.714c.355 0 .643-.384.643-.857V18.4c0-1.325-.806-2.4-1.8-2.4zM19 15a2 2 0 100-4 2 2 0 000 4zM20.2 16h-.224a1.86 1.86 0 01-.976.286c-.348 0-.678-.104-.976-.286H17.8c-.994 0-1.8 1.075-1.8 2.4v.743c0 .473.288.857.643.857h4.714c.355 0 .643-.384.643-.857V18.4c0-1.325-.806-2.4-1.8-2.4zM3 4h18v6.764A2.989 2.989 0 0019 10V6H5v4a2.99 2.99 0 00-2 .764V4z",
    fill: "#000"
  })));
}

var _path$27;

function _extends$2f() { _extends$2f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2f.apply(this, arguments); }

function SvgCloseSquareSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2f({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$27 || (_path$27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V6a2 2 0 00-2-2H4zm11.251 4.749a.85.85 0 010 1.202L13.201 12l2.05 2.048a.85.85 0 11-1.202 1.202L12 13.202l-2.049 2.049a.85.85 0 01-1.202-1.202L10.8 12l-2.05-2.05A.85.85 0 019.95 8.75L12 10.799l2.05-2.05a.85.85 0 011.201 0z",
    fill: "#000"
  })));
}

var _path$26;

function _extends$2e() { _extends$2e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2e.apply(this, arguments); }

function SvgCogSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2e({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$26 || (_path$26 = /*#__PURE__*/React.createElement("path", {
    d: "M21.328 14.403l-1.717-.992a7.766 7.766 0 000-2.83l1.717-.992a.487.487 0 00.222-.565 10.043 10.043 0 00-2.206-3.814.485.485 0 00-.596-.093l-1.718.992a7.61 7.61 0 00-2.452-1.415v-1.98a.483.483 0 00-.379-.472 10.137 10.137 0 00-4.403 0 .483.483 0 00-.379.472v1.984a7.85 7.85 0 00-2.451 1.415L5.252 5.12a.48.48 0 00-.597.093A9.982 9.982 0 002.45 9.028a.482.482 0 00.222.565l1.718.992a7.767 7.767 0 000 2.83l-1.718.992a.487.487 0 00-.222.565 10.044 10.044 0 002.206 3.814.485.485 0 00.597.093l1.718-.992a7.61 7.61 0 002.451 1.415v1.984c0 .226.157.424.38.472 1.479.33 2.995.315 4.402 0a.483.483 0 00.38-.472v-1.984a7.851 7.851 0 002.451-1.415l1.718.992a.48.48 0 00.597-.093 9.983 9.983 0 002.205-3.814.498.498 0 00-.226-.569zm-9.33.819a3.23 3.23 0 01-3.226-3.226 3.23 3.23 0 013.226-3.226 3.23 3.23 0 013.226 3.226 3.23 3.23 0 01-3.226 3.226z",
    fill: "#000"
  })));
}

var _path$25;

function _extends$2d() { _extends$2d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2d.apply(this, arguments); }

function SvgCommentAltOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2d({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$25 || (_path$25 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 2h-15A2.502 2.502 0 002 4.5v11.25c0 1.379 1.121 2.5 2.5 2.5h3.75v3.281a.467.467 0 00.746.375l4.879-3.656H19.5c1.379 0 2.5-1.121 2.5-2.5V4.5C22 3.121 20.879 2 19.5 2zm.625 13.75a.627.627 0 01-.625.625h-6.25l-.5.375-2.625 1.969v-2.344H4.5a.627.627 0 01-.625-.625V4.5c0-.344.281-.625.625-.625h15c.344 0 .625.281.625.625v11.25z",
    fill: "#000"
  })));
}

var _path$24;

function _extends$2c() { _extends$2c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2c.apply(this, arguments); }

function SvgCommentAltSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2c({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$24 || (_path$24 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 2h-15A2.502 2.502 0 002 4.5v11.25c0 1.378 1.122 2.499 2.5 2.499h3.75v3.281a.47.47 0 00.746.379l4.879-3.66H19.5c1.378 0 2.5-1.121 2.5-2.5V4.5C22 3.122 20.877 2 19.5 2z",
    fill: "#000"
  })));
}

var _path$23;

function _extends$2b() { _extends$2b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2b.apply(this, arguments); }

function SvgCommentSlashSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2b({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$23 || (_path$23 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11.502c0 1.55.668 2.968 1.78 4.084-.393 1.572-1.697 2.975-1.712 2.994a.25.25 0 00.181.422c2.072 0 3.625-.994 4.394-1.607a9.53 9.53 0 003.356.607c.856 0 1.678-.113 2.45-.313L4.277 9.827A5.363 5.363 0 004 11.502zm17.805 6.815l-3.575-2.762C19.33 14.442 20 13.039 20 11.502c0-3.591-3.581-6.5-8-6.5-2.034 0-3.881.628-5.294 1.647L3.421 4.107a.502.502 0 00-.703.087l-.613.788a.498.498 0 00.088.7l18.387 14.21a.502.502 0 00.703-.088l.613-.79a.495.495 0 00-.09-.698z",
    fill: "#000"
  })));
}

var _path$22;

function _extends$2a() { _extends$2a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2a.apply(this, arguments); }

function SvgCommentSmileSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2a({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$22 || (_path$22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 2.5h14.999c1.379 0 2.5 1.121 2.5 2.5v10.25c0 1.378-1.121 2.499-2.5 2.499h-5.625l-4.878 3.66a.47.47 0 01-.746-.379V17.75H4.5a2.502 2.502 0 01-2.5-2.5V5C2 3.622 3.121 2.5 4.5 2.5zm11.274 5.078a1.077 1.077 0 10-2.156 0 1.077 1.077 0 102.156 0zm-5.39 0a1.077 1.077 0 10-2.156 0 1.077 1.077 0 102.156 0zm1.617 6.468c1.499 0 2.907-.66 3.867-1.813.455-.549-.377-1.236-.829-.69a3.947 3.947 0 01-3.038 1.421 3.936 3.936 0 01-3.039-1.421c-.458-.546-1.286.141-.828.69A5.018 5.018 0 0012 14.046z",
    fill: "#000"
  })));
}

var _path$21;

function _extends$29() { _extends$29 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$29.apply(this, arguments); }

function SvgCommentSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$29({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$21 || (_path$21 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.25c-5.523 0-10 3.637-10 8.125 0 1.938.836 3.71 2.227 5.105-.489 1.97-2.122 3.723-2.141 3.743a.31.31 0 00-.059.34c.051.117.16.187.285.187 2.59 0 4.532-1.242 5.493-2.008 1.277.48 2.695.758 4.195.758 5.523 0 10-3.637 10-8.125 0-4.488-4.477-8.125-10-8.125z",
    fill: "#000"
  })));
}

var _path$20;

function _extends$28() { _extends$28 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$28.apply(this, arguments); }

function SvgComments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$28({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$20 || (_path$20 = /*#__PURE__*/React.createElement("path", {
    d: "M16.444 9.778c0-3.07-3.232-5.556-7.222-5.556S2 6.708 2 9.778c0 1.19.49 2.288 1.32 3.194-.466 1.049-1.233 1.882-1.244 1.893a.276.276 0 00-.052.302.272.272 0 00.254.166c1.27 0 2.323-.427 3.08-.868a8.834 8.834 0 003.864.868c3.99 0 7.222-2.486 7.222-5.555zm4.237 7.639c.83-.903 1.319-2.004 1.319-3.195 0-2.323-1.858-4.312-4.49-5.142.032.229.046.462.046.698 0 3.677-3.74 6.666-8.334 6.666-.375 0-.74-.027-1.1-.066 1.093 1.997 3.663 3.4 6.656 3.4 1.423 0 2.746-.32 3.864-.868.757.44 1.81.868 3.08.868a.278.278 0 00.201-.469c-.01-.01-.777-.84-1.242-1.892z",
    fill: "#000"
  })));
}

var _path$1$;

function _extends$27() { _extends$27 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$27.apply(this, arguments); }

function SvgCommentsSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$27({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1$ || (_path$1$ = /*#__PURE__*/React.createElement("path", {
    d: "M16.448 9.552C16.448 6.498 13.187 4 9.231 4 5.24 4 2.014 6.498 2.014 9.552c0 1.214.485 2.29 1.318 3.192-.486 1.076-1.249 1.909-1.249 1.909-.07.069-.104.208-.07.312.07.104.14.139.278.139 1.25 0 2.29-.417 3.054-.868 1.11.555 2.463.867 3.886.867 3.956 0 7.217-2.463 7.217-5.551zm4.233 7.634C21.48 16.283 22 15.208 22 13.993c0-2.29-1.874-4.302-4.51-5.135.034.243.069.486.069.694 0 3.678-3.748 6.662-8.328 6.662-.382 0-.763 0-1.11-.035 1.075 1.978 3.643 3.366 6.662 3.366 1.422 0 2.74-.312 3.851-.868a6.027 6.027 0 003.088.868c.104 0 .209-.035.243-.139.035-.104.035-.243-.07-.312 0 0-.762-.833-1.213-1.909z",
    fill: "#000"
  })));
}

var _path$1_;

function _extends$26() { _extends$26 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$26.apply(this, arguments); }

function SvgCopySolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$26({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1_ || (_path$1_ = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 19.5v1.563c0 .517-.42.937-.938.937H4.188a.937.937 0 01-.938-.938V6.688c0-.517.42-.937.938-.937H7v11.563A2.19 2.19 0 009.188 19.5h6.562zm0-13.438V2H9.187a.937.937 0 00-.937.938v14.374c0 .518.42.938.938.938h10.624c.518 0 .938-.42.938-.938V7h-4.063a.94.94 0 01-.937-.938zm4.725-1.212L17.9 2.275A.938.938 0 0017.237 2H17v3.75h3.75v-.237a.938.938 0 00-.275-.663z",
    fill: "#000"
  })));
}

var _path$1Z;

function _extends$25() { _extends$25 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$25.apply(this, arguments); }

function SvgCurveSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$25({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1Z || (_path$1Z = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5.077V3.538a1.538 1.538 0 113.077 0v1.539c0 7.647 6.2 13.846 13.846 13.846h1.539a1.538 1.538 0 110 3.077h-1.539C9.577 22 2 14.423 2 5.077z",
    fill: "#000"
  })));
}

var _path$1Y;

function _extends$24() { _extends$24 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$24.apply(this, arguments); }

function SvgEarphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$24({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1Y || (_path$1Y = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 2h-1.667a2.333 2.333 0 000 4.667H18V2zM6 6h1.667a2.333 2.333 0 010 4.667H6V6zm-1.333 4.667v10.668a.665.665 0 11-1.33 0V10.554A2 2 0 014 6.667h.667v4zm16 1.39V6.553A2 2 0 0020 2.667h-.667v9.39a1 1 0 00-.666.943v4.667a1 1 0 00.666.943v2.723a.667.667 0 001.334 0V18.61a1 1 0 00.666-.943V13a1 1 0 00-.666-.943z",
    fill: "#000"
  })));
}

var _path$1X;

function _extends$23() { _extends$23 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$23.apply(this, arguments); }

function SvgEarphoneBluetooth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$23({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1X || (_path$1X = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.333 2.8a.8.8 0 00-.8-.8H16a2.667 2.667 0 100 5.333h.533a.8.8 0 00.8-.8V2.8zM6.667 6.133a.8.8 0 01.8-.8H8a2.667 2.667 0 010 5.334h-.533a.8.8 0 01-.8-.8V6.133zM3.333 9.491A2 2 0 014.666 6h.667v3.999h-.666v6.667a.667.667 0 01-1.334 0V9.49zm18-4.824c0 .592-.257 1.124-.666 1.49v7.176a.667.667 0 11-1.334 0V6.667h-.666v-4h.666a2 2 0 012 2zm-8.361 6.779a.47.47 0 00-.507-.067.485.485 0 00-.274.44v3.813l-2.077-1.762a.47.47 0 00-.67.062.49.49 0 00.06.683l2.419 2.052-2.418 2.051a.49.49 0 00-.061.683.47.47 0 00.67.062l2.077-1.761v3.813c0 .188.106.36.274.44a.47.47 0 00.507-.067l2.857-2.425a.488.488 0 000-.745l-2.418-2.051 2.418-2.052a.488.488 0 000-.745l-2.857-2.424zm1.808 7.645l-1.637-1.39v2.779l1.637-1.39zm-1.637-6.238v2.779l1.637-1.39-1.637-1.389z",
    fill: "#000"
  })));
}

var _path$1W;

function _extends$22() { _extends$22 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$22.apply(this, arguments); }

function SvgEditSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$22({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1W || (_path$1W = /*#__PURE__*/React.createElement("path", {
    d: "M15.98 5.998L19.11 9.13a.34.34 0 010 .48l-7.583 7.583-3.222.357a.675.675 0 01-.747-.746l.358-3.222L15.5 5.998a.34.34 0 01.48 0zm5.624-.795L19.91 3.51a1.358 1.358 0 00-1.917 0l-1.23 1.229a.34.34 0 000 .479l3.133 3.132a.34.34 0 00.479 0l1.23-1.23a1.358 1.358 0 000-1.916zm-6.27 9.927v3.535H4.221V7.554h7.98a.427.427 0 00.294-.122l1.39-1.389a.417.417 0 00-.296-.711H3.667C2.747 5.332 2 6.078 2 6.998V19.22c0 .92.747 1.667 1.667 1.667h12.222c.92 0 1.667-.746 1.667-1.667v-5.479a.417.417 0 00-.712-.295l-1.39 1.389a.427.427 0 00-.12.295z",
    fill: "#000"
  })));
}

var _circle$1, _circle2$1, _circle3$1;

function _extends$21() { _extends$21 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$21.apply(this, arguments); }

function SvgEllipsisVMediumSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$21({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$1 || (_circle$1 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 2,
    fill: "#000"
  })), _circle2$1 || (_circle2$1 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2,
    fill: "#000"
  })), _circle3$1 || (_circle3$1 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 19,
    r: 2,
    fill: "#000"
  })));
}

var _path$1V;

function _extends$20() { _extends$20 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$20.apply(this, arguments); }

function SvgEnvelopeOpenTextSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$20({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1V || (_path$1V = /*#__PURE__*/React.createElement("path", {
    d: "M8.875 10.438h6.25c.345 0 .625-.28.625-.625v-.625a.625.625 0 00-.625-.625h-6.25a.625.625 0 00-.625.625v.625c0 .345.28.625.625.625zm-.625 3.124c0 .346.28.626.625.626h6.25c.345 0 .625-.28.625-.626v-.624a.625.625 0 00-.625-.625h-6.25a.625.625 0 00-.625.625v.624zM12 18.294a3.12 3.12 0 01-1.83-.593L2 11.799v8.326C2 21.161 2.84 22 3.875 22h16.25C21.16 22 22 21.16 22 20.125v-8.326l-8.17 5.902a3.124 3.124 0 01-1.83.593zm9.282-9.929a73.07 73.07 0 00-1.157-.89V5.75c0-1.035-.84-1.875-1.875-1.875h-3.03l-.353-.256C14.211 3.139 12.907 1.986 12 2c-.906-.014-2.21 1.14-2.868 1.619l-.353.256H5.75c-1.036 0-1.875.84-1.875 1.875v1.724c-.483.365-.81.62-1.157.891A1.875 1.875 0 002 9.841v.416l3.75 2.709V5.75h12.5v7.216l3.75-2.71v-.415c0-.576-.265-1.12-.718-1.476z",
    fill: "#000"
  })));
}

var _path$1U;

function _extends$1$() { _extends$1$ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1$.apply(this, arguments); }

function SvgEquilateralTriangleOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1$({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1U || (_path$1U = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.819 5.604c.562-.805 1.8-.805 2.362 0l8.578 12.289c.63.9-.047 2.107-1.18 2.107H3.421c-1.134 0-1.81-1.207-1.181-2.107l8.578-12.29zM12 7.17L4.306 18.193h15.388L12 7.17z",
    fill: "#000"
  })));
}

var _path$1T;

function _extends$1_() { _extends$1_ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1_.apply(this, arguments); }

function SvgEraserSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1_({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1T || (_path$1T = /*#__PURE__*/React.createElement("path", {
    d: "M21.45 12.7a1.875 1.875 0 000-2.65L15.2 3.8a1.875 1.875 0 00-2.65 0l-10 10a1.875 1.875 0 000 2.65L6.3 20.2c.35.352.828.55 1.325.55h13.906c.26 0 .469-.21.469-.469V18.72a.469.469 0 00-.469-.469h-5.63l5.55-5.55zM9.63 10.255l5.366 5.367-2.63 2.629H7.884l-3.125-3.125 4.87-4.87z",
    fill: "#000"
  })));
}

var _path$1S;

function _extends$1Z() { _extends$1Z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1Z.apply(this, arguments); }

function SvgExclamationCircleSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1Z({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1S || (_path$1S = /*#__PURE__*/React.createElement("path", {
    d: "M12.355 22.122c5.466 0 9.995-4.528 9.995-9.994 0-5.467-4.539-9.995-10.006-9.995-5.466 0-9.994 4.528-9.994 9.995 0 5.466 4.538 9.994 10.005 9.994zm-.01-8.22c-.527 0-.826-.3-.836-.846l-.134-5.168c-.02-.536.382-.928.96-.928.566 0 .99.392.969.939l-.145 5.157c-.01.557-.31.846-.815.846zm0 3.3c-.61 0-1.135-.474-1.135-1.072 0-.598.516-1.073 1.134-1.073.62 0 1.125.464 1.125 1.073 0 .608-.516 1.072-1.124 1.072z",
    fill: "#000"
  })));
}

var _path$1R;

function _extends$1Y() { _extends$1Y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1Y.apply(this, arguments); }

function SvgExpandSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1Y({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1R || (_path$1R = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.607V3.071C2 2.478 2.478 2 3.071 2h5.536c.295 0 .536.241.536.536V4.32a.537.537 0 01-.536.536h-3.75v3.75a.537.537 0 01-.536.536H2.536A.537.537 0 012 8.607zm12.857-6.071V4.32c0 .295.241.536.536.536h3.75v3.75c0 .295.24.536.536.536h1.785A.537.537 0 0022 8.607V3.071C22 2.478 21.522 2 20.929 2h-5.536a.537.537 0 00-.536.536zm6.607 12.321H19.68a.537.537 0 00-.536.536v3.75h-3.75a.537.537 0 00-.536.536v1.785c0 .295.241.536.536.536h5.536c.593 0 1.071-.478 1.071-1.071v-5.536a.537.537 0 00-.536-.536zM9.143 21.464V19.68a.537.537 0 00-.536-.536h-3.75v-3.75a.537.537 0 00-.536-.536H2.536a.537.537 0 00-.536.536v5.536C2 21.522 2.478 22 3.071 22h5.536a.537.537 0 00.536-.536z",
    fill: "#000"
  })));
}

var _path$1Q;

function _extends$1X() { _extends$1X = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1X.apply(this, arguments); }

function SvgEyeSlashSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1X({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1Q || (_path$1Q = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.5c-2.37 0-4.29-1.835-4.466-4.16L4.256 9.807c-.43.54-.827 1.112-1.147 1.737a1.011 1.011 0 000 .912C4.803 15.763 8.159 18 11.999 18a9.71 9.71 0 002.435-.327l-1.622-1.254c-.267.051-.54.078-.812.081zm9.807 1.816l-3.455-2.67a10.351 10.351 0 002.54-3.19 1.01 1.01 0 000-.912C19.195 8.237 15.841 6 12 6a9.63 9.63 0 00-4.604 1.178L3.421 4.105a.5.5 0 00-.702.088l-.614.79a.5.5 0 00.088.701l18.386 14.21a.498.498 0 00.702-.087l.614-.79a.5.5 0 00-.088-.701zm-5.741-4.438l-1.229-.95a2.961 2.961 0 00-3.628-3.81c.188.256.29.565.29.882-.004.106-.02.21-.047.313l-2.3-1.778A4.447 4.447 0 0112 7.5a4.498 4.498 0 014.5 4.5c0 .676-.165 1.306-.434 1.879z",
    fill: "#000"
  })));
}

var _path$1P;

function _extends$1W() { _extends$1W = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1W.apply(this, arguments); }

function SvgEyeSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1W({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1P || (_path$1P = /*#__PURE__*/React.createElement("path", {
    d: "M21.88 11.493c-1.884-3.674-5.612-6.16-9.88-6.16-4.268 0-7.997 2.488-9.88 6.16a1.123 1.123 0 000 1.014c1.884 3.674 5.612 6.16 9.88 6.16 4.268 0 7.997-2.488 9.88-6.16a1.124 1.124 0 000-1.014zM12 17a5 5 0 110-10 5 5 0 010 10zm0-8.333a3.31 3.31 0 00-.879.131 1.661 1.661 0 01-2.323 2.323A3.326 3.326 0 1012 8.667z",
    fill: "#000"
  })));
}

var _path$1O;

function _extends$1V() { _extends$1V = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1V.apply(this, arguments); }

function SvgFileAddSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1V({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1O || (_path$1O = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.763 7.06V2h-7.44a.89.89 0 00-.893.893v17.262a.89.89 0 00.893.893h10.536v-.953H13.43c-.789 0-1.428-.64-1.428-1.428v-.953c0-.789.64-1.428 1.428-1.428h1.429v-1.429c0-.789.64-1.428 1.428-1.428h.953c.167 0 .327.028.476.08V7.953h-5.06a.895.895 0 01-.893-.892zm5.953-.525v.227h-4.762V2h.227c.238 0 .465.093.632.26l3.642 3.646a.89.89 0 01.26.629zm-1.905 8.322c0-.263.213-.476.476-.476h.953c.263 0 .476.213.476.476v2.381h2.38c.264 0 .477.213.477.476v.953a.476.476 0 01-.476.476h-2.381v2.38a.476.476 0 01-.476.477h-.953a.476.476 0 01-.476-.476v-2.381h-2.38a.476.476 0 01-.477-.476v-.953c0-.263.213-.476.476-.476h2.381v-2.38z",
    fill: "#000"
  })));
}

var _path$1N;

function _extends$1U() { _extends$1U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1U.apply(this, arguments); }

function SvgFileAltSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1U({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1N || (_path$1N = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 7.313V2H5.437a.935.935 0 00-.937.938v18.125c0 .519.418.937.938.937h13.125c.519 0 .937-.418.937-.938V8.25h-5.313a.94.94 0 01-.937-.938zm2.5 9.218a.47.47 0 01-.469.469H8.72a.47.47 0 01-.469-.469v-.312a.47.47 0 01.469-.469h6.562a.47.47 0 01.469.469v.312zm0-2.5a.47.47 0 01-.469.469H8.72a.47.47 0 01-.469-.469v-.312a.47.47 0 01.469-.469h6.562a.47.47 0 01.469.469v.312zm0-2.812v.312a.47.47 0 01-.469.469H8.72a.47.47 0 01-.469-.469v-.312a.47.47 0 01.469-.469h6.562a.47.47 0 01.469.469zm3.75-4.457V7h-5V2h.238c.25 0 .489.098.664.273l3.825 3.829a.935.935 0 01.273.66z",
    fill: "#377DFF"
  })));
}

var _path$1M;

function _extends$1T() { _extends$1T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1T.apply(this, arguments); }

function SvgFilmSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1T({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1M || (_path$1M = /*#__PURE__*/React.createElement("path", {
    d: "M21.063 4.5h-.313v.781a.47.47 0 01-.469.469H18.72a.47.47 0 01-.469-.469V4.5H5.75v.781a.47.47 0 01-.469.469H3.72a.47.47 0 01-.469-.469V4.5h-.313A.935.935 0 002 5.438v13.125c0 .519.418.937.938.937h.312v-.781a.47.47 0 01.469-.469H5.28a.47.47 0 01.469.469v.781h12.5v-.781a.47.47 0 01.469-.469h1.562a.47.47 0 01.469.469v.781h.313c.519 0 .937-.418.937-.938V5.438a.935.935 0 00-.938-.937zM5.75 16.531a.47.47 0 01-.469.469H3.72a.47.47 0 01-.469-.469V14.97a.47.47 0 01.469-.469H5.28a.47.47 0 01.469.469v1.562zm0-3.75a.47.47 0 01-.469.469H3.72a.47.47 0 01-.469-.469V11.22a.47.47 0 01.469-.469H5.28a.47.47 0 01.469.469v1.562zm0-3.75a.47.47 0 01-.469.469H3.72a.47.47 0 01-.469-.469V7.47A.47.47 0 013.719 7H5.28a.47.47 0 01.469.469V9.03zm10.625 8.125a.47.47 0 01-.469.469H8.094a.47.47 0 01-.469-.469v-3.75a.47.47 0 01.469-.469h7.812a.47.47 0 01.469.47v3.75zm0-6.562a.47.47 0 01-.469.469H8.094a.47.47 0 01-.469-.47v-3.75a.47.47 0 01.469-.468h7.812a.47.47 0 01.469.469v3.75zm4.375 5.937a.47.47 0 01-.469.469H18.72a.47.47 0 01-.469-.469V14.97a.47.47 0 01.469-.469h1.562a.47.47 0 01.469.469v1.562zm0-3.75a.47.47 0 01-.469.469H18.72a.47.47 0 01-.469-.469V11.22a.47.47 0 01.469-.469h1.562a.47.47 0 01.469.469v1.562zm0-3.75a.47.47 0 01-.469.469H18.72a.47.47 0 01-.469-.469V7.47A.47.47 0 0118.719 7h1.562a.47.47 0 01.469.469V9.03z",
    fill: "#000"
  })));
}

var _path$1L;

function _extends$1S() { _extends$1S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1S.apply(this, arguments); }

function SvgFluentLiveFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1S({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1L || (_path$1L = /*#__PURE__*/React.createElement("path", {
    d: "M6.343 4.938a1 1 0 010 1.415 8.003 8.003 0 000 11.317 1 1 0 11-1.414 1.414c-3.907-3.906-3.907-10.24 0-14.146a1 1 0 011.414 0zm12.732 0c3.906 3.907 3.906 10.24 0 14.146a1 1 0 01-1.415-1.414 8.003 8.003 0 000-11.317 1 1 0 011.415-1.415zM9.31 7.812a1 1 0 010 1.414 3.92 3.92 0 000 5.544 1 1 0 11-1.415 1.414 5.92 5.92 0 010-8.372 1 1 0 011.415 0zm6.958 0a5.92 5.92 0 010 8.372 1 1 0 01-1.414-1.414 3.92 3.92 0 000-5.544 1 1 0 011.414-1.414zm-4.186 2.77a1.5 1.5 0 110 3 1.5 1.5 0 010-3z",
    fill: "#CD3B33"
  })));
}

var _path$1K;

function _extends$1R() { _extends$1R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1R.apply(this, arguments); }

function SvgFluentLiveOffFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1R({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1K || (_path$1K = /*#__PURE__*/React.createElement("path", {
    d: "M3.28 2.22a.75.75 0 10-1.06 1.06l2.203 2.203c-3.393 3.93-3.224 9.872.506 13.602a1 1 0 001.414-1.415 8.004 8.004 0 01-.501-10.768l1.52 1.52a5.922 5.922 0 00.533 7.763A1 1 0 009.31 14.77a3.922 3.922 0 01-.513-4.913l1.835 1.836a1.503 1.503 0 001.838 1.838l8.25 8.25a.75.75 0 101.06-1.06L3.28 2.22zm15.748 13.626l1.462 1.462c2.414-3.86 1.942-9.012-1.415-12.37a1 1 0 10-1.415 1.415 8.006 8.006 0 011.368 9.493zm-3.098-3.098l1.591 1.591a5.922 5.922 0 00-1.253-6.527 1 1 0 10-1.414 1.414 3.917 3.917 0 011.076 3.522z",
    fill: "#CD3B33"
  })));
}

var _path$1J;

function _extends$1Q() { _extends$1Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1Q.apply(this, arguments); }

function SvgFolderOpenSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1Q({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1J || (_path$1J = /*#__PURE__*/React.createElement("path", {
    d: "M21.885 13.253l-2.515 4.311a2.223 2.223 0 01-1.919 1.103H3.563a.833.833 0 01-.72-1.254l2.515-4.31A2.222 2.222 0 017.278 12h13.887a.833.833 0 01.72 1.253zM7.278 10.89h11.389V9.222c0-.92-.747-1.666-1.667-1.666h-5.556L9.222 5.333H3.667C2.747 5.333 2 6.08 2 7v9.654l2.399-4.111a3.345 3.345 0 012.879-1.654z",
    fill: "#000"
  })));
}

var _path$1I;

function _extends$1P() { _extends$1P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1P.apply(this, arguments); }

function SvgGiftSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1P({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1I || (_path$1I = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 19.5c0 .691.559 1.25 1.25 1.25h6.25V14.5h-7.5v5zm10 1.25h6.25c.691 0 1.25-.559 1.25-1.25v-5h-7.5v6.25zm7.5-12.5h-1.645c.243-.473.395-.996.395-1.563a3.443 3.443 0 00-3.438-3.437c-1.625 0-2.675.832-4.023 2.668C10.691 4.082 9.641 3.25 8.016 3.25a3.443 3.443 0 00-3.438 3.438c0 .566.149 1.09.395 1.562H3.25C2.559 8.25 2 8.809 2 9.5v3.125c0 .344.281.625.625.625h18.75a.627.627 0 00.625-.625V9.5c0-.691-.559-1.25-1.25-1.25zm-12.738 0a1.562 1.562 0 110-3.125c.777 0 1.351.129 3.363 3.125H8.012zm8.05 0H12.7c2.008-2.988 2.567-3.125 3.364-3.125a1.562 1.562 0 110 3.125z",
    fill: "#000"
  })));
}

var _path$1H;

function _extends$1O() { _extends$1O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1O.apply(this, arguments); }

function SvgGlobeSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1O({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1H || (_path$1H = /*#__PURE__*/React.createElement("path", {
    d: "M15.57 8.129C14.987 4.529 13.608 2 12.003 2S9.018 4.528 8.434 8.129h7.137zM8.132 12c0 .895.048 1.754.133 2.58h7.472a25.266 25.266 0 000-5.16H8.264A25.273 25.273 0 008.131 12zm13.093-3.871a10.022 10.022 0 00-6.371-5.71c.984 1.363 1.661 3.416 2.016 5.71h4.355zM9.147 2.419A10.014 10.014 0 002.78 8.13h4.355c.351-2.294 1.028-4.347 2.012-5.71zm12.508 7H17.03c.085.847.133 1.714.133 2.581s-.048 1.734-.133 2.58h4.621a9.916 9.916 0 00.347-2.58c0-.895-.125-1.754-.343-2.58zM6.841 12c0-.867.048-1.734.133-2.58H2.349A10.089 10.089 0 002.002 12c0 .895.13 1.754.347 2.58h4.62A27.3 27.3 0 016.842 12zm1.593 3.871c.584 3.6 1.963 6.129 3.568 6.129s2.984-2.528 3.569-6.129H8.434zm6.423 5.71a10.03 10.03 0 006.37-5.71h-4.354c-.355 2.294-1.032 4.347-2.016 5.71zM2.78 15.87a10.02 10.02 0 006.371 5.71c-.984-1.363-1.661-3.416-2.016-5.71H2.78z",
    fill: "#000"
  })));
}

var _path$1G;

function _extends$1N() { _extends$1N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1N.apply(this, arguments); }

function SvgHandPaperSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1N({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1G || (_path$1G = /*#__PURE__*/React.createElement("path", {
    d: "M19.218 7c-.876-.016-1.593.717-1.593 1.593V12h-.313V5.117c0-.876-.716-1.61-1.593-1.593a1.562 1.562 0 00-1.531 1.562V12h-.313V3.593c0-.876-.717-1.61-1.593-1.593a1.562 1.562 0 00-1.532 1.563V12h-.313V5.156c0-.876-.717-1.61-1.593-1.593a1.563 1.563 0 00-1.531 1.562v9.218l-1.237-1.7a1.563 1.563 0 00-2.527 1.838l4.906 6.747A1.875 1.875 0 009.972 22h7.718c.87 0 1.626-.599 1.825-1.445l1.036-4.401c.132-.563.199-1.14.199-1.718V8.563c0-.853-.683-1.546-1.532-1.563z",
    fill: "#000"
  })));
}

var _path$1F;

function _extends$1M() { _extends$1M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1M.apply(this, arguments); }

function SvgHeadphonesAltSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1M({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1F || (_path$1F = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 13.25h-.625c-1.38 0-2.5 1.121-2.5 2.505v2.49a2.502 2.502 0 002.5 2.505h.625c.69 0 1.25-.56 1.25-1.252v-4.996c0-.692-.56-1.252-1.25-1.252zm8.125 0h-.625c-.69 0-1.25.56-1.25 1.252v4.996c0 .691.56 1.252 1.25 1.252h.625c1.38 0 2.5-1.122 2.5-2.505v-2.49a2.502 2.502 0 00-2.5-2.505zM12 3.25c-5.59 0-9.821 4.654-10 10v4.375c0 .345.28.625.625.625h.625c.345 0 .625-.28.625-.625V13.25c0-4.48 3.646-8.117 8.125-8.118 4.48 0 8.125 3.639 8.125 8.118v4.375c0 .345.28.625.625.625h.625c.345 0 .625-.28.625-.625V13.25c-.178-5.346-4.41-10-10-10z",
    fill: "#000"
  })));
}

var _path$1E;

function _extends$1L() { _extends$1L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1L.apply(this, arguments); }

function SvgHeadsetSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1L({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1E || (_path$1E = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10.125c0-.69-.56-1.25-1.25-1.25h-.625a2.5 2.5 0 00-2.5 2.5v1.875a2.5 2.5 0 002.5 2.5h.625c.69 0 1.25-.56 1.25-1.25v-4.375zm6.875 5.625a2.5 2.5 0 002.5-2.5v-1.875a2.5 2.5 0 00-2.5-2.5h-.625c-.69 0-1.25.56-1.25 1.25V14.5c0 .69.56 1.25 1.25 1.25h.625zM12 2C6.421 2 2.179 6.642 2 12v.625c0 .345.28.625.625.625h.625c.345 0 .625-.28.625-.625V12c0-4.48 3.645-8.125 8.125-8.125S20.125 7.52 20.125 12h-.005c.003.095.005 6.473.005 6.473 0 .913-.74 1.652-1.652 1.652H14.5c0-1.035-.84-1.875-1.875-1.875h-1.25a1.875 1.875 0 000 3.75h7.098A3.527 3.527 0 0022 18.473V12c-.179-5.358-4.421-10-10-10z",
    fill: "#fff"
  })));
}

var _path$1D;

function _extends$1K() { _extends$1K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1K.apply(this, arguments); }

function SvgHistorySolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1K({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1D || (_path$1D = /*#__PURE__*/React.createElement("path", {
    d: "M22 11.981c.01 5.51-4.483 10.015-9.993 10.019a9.958 9.958 0 01-6.283-2.214.967.967 0 01-.074-1.436l.454-.454a.97.97 0 011.286-.08A7.39 7.39 0 0012 19.419 7.415 7.415 0 0019.42 12 7.415 7.415 0 0012 4.58a7.394 7.394 0 00-5.083 2.014l2.046 2.047a.645.645 0 01-.456 1.1H2.645A.645.645 0 012 9.098V3.235a.645.645 0 011.101-.456l1.991 1.99A9.966 9.966 0 0112 2c5.517 0 9.99 4.467 10 9.981zm-7.295 3.177l.396-.51a.968.968 0 00-.17-1.357l-1.64-1.277V7.806a.968.968 0 00-.968-.967h-.646a.968.968 0 00-.967.967v5.47l2.637 2.052a.968.968 0 001.358-.17z",
    fill: "#fff"
  })));
}

var _path$1C;

function _extends$1J() { _extends$1J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1J.apply(this, arguments); }

function SvgHomeworkSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1J({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1C || (_path$1C = /*#__PURE__*/React.createElement("path", {
    d: "M15.13 15.584V5.706A.703.703 0 0014.425 5H4.813A2.819 2.819 0 002 7.822v9.409a2.819 2.819 0 002.813 2.822h9.613c.39 0 .703-.314.703-.706v-.47c0-.22-.102-.42-.26-.55-.124-.452-.124-1.743 0-2.196a.701.701 0 00.26-.547zm-1.953 2.588H4.813a.942.942 0 010-1.882h8.364a10.615 10.615 0 000 1.882zM17.819 18.944v-1.506c0-.153.124-.277.277-.277h3.626c.154 0 .278.124.278.277v1.506c0 .611-.497 1.108-1.11 1.11h-1.962a1.107 1.107 0 01-1.11-1.11zm4.18-2.8V7.568l-1.637-2.331a.555.555 0 00-.908 0l-1.637 2.332v8.578c0 .154.124.278.278.278h3.626a.28.28 0 00.279-.28zm-2.09-8.5l-.784.785-.593-.593.87-1.238h1.015l.87 1.238-.594.593-.784-.784z",
    fill: "#000"
  })));
}

var _path$1B, _path2$f;

function _extends$1I() { _extends$1I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1I.apply(this, arguments); }

function SvgHorizontalOneColumnsOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1I({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1B || (_path$1B = /*#__PURE__*/React.createElement("path", {
    d: "M19.795 5H4.205C3.54 5 3 5.54 3 6.205v11.411c0 .666.54 1.205 1.205 1.205h15.59c.665 0 1.205-.54 1.205-1.205V6.206C21 5.54 20.46 5 19.795 5zm-.151 12.616H4.356a.15.15 0 01-.15-.15V6.355a.15.15 0 01.15-.15h15.288a.15.15 0 01.15.15v11.11a.15.15 0 01-.15.15z",
    fill: "#000"
  })), _path2$f || (_path2$f = /*#__PURE__*/React.createElement("path", {
    d: "M15.813 9.124c-.07-.243-.156-.667-.156-.667h-.01s-.087.424-.157.667l-.223.754h.765l-.219-.754zm-1.872 2.007l1.155-3.397a.24.24 0 01.23-.162h.652c.103 0 .195.066.23.162l1.154 3.397a.242.242 0 01-.229.32h-.46a.242.242 0 01-.23-.173l-.19-.64h-1.209l-.183.638a.243.243 0 01-.23.175h-.46a.243.243 0 01-.23-.32zM7.118 7.572h-.602a.301.301 0 00-.302.3v8.378c0 .166.135.301.302.301h.602a.301.301 0 00.302-.3V7.872a.301.301 0 00-.302-.301zM9.69 7.572h-.603a.301.301 0 00-.301.3v8.378c0 .166.135.301.301.301h.603a.301.301 0 00.301-.3V7.872a.301.301 0 00-.301-.301zM12.261 7.572h-.602a.301.301 0 00-.302.3v8.378c0 .166.135.301.302.301h.602a.301.301 0 00.302-.3V7.872a.301.301 0 00-.302-.301zM14.833 12.714h-.603a.301.301 0 00-.301.302v3.234c0 .166.134.301.3.301h.604a.301.301 0 00.3-.3v-3.235a.301.301 0 00-.3-.302zM17.404 12.714h-.603a.301.301 0 00-.301.302v3.234c0 .166.135.301.301.301h.603a.301.301 0 00.301-.3v-3.235a.301.301 0 00-.301-.302z",
    fill: "#000"
  })));
}

var _path$1A, _path2$e;

function _extends$1H() { _extends$1H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1H.apply(this, arguments); }

function SvgHorizontalTwoColumnsAOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1H({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1A || (_path$1A = /*#__PURE__*/React.createElement("path", {
    d: "M19.795 5H4.205C3.54 5 3 5.54 3 6.205v11.411c0 .666.54 1.205 1.205 1.205h15.59c.665 0 1.205-.54 1.205-1.205V6.206C21 5.54 20.46 5 19.795 5zm-.151 12.616H4.356a.15.15 0 01-.15-.15V6.355a.15.15 0 01.15-.15h15.288a.15.15 0 01.15.15v11.11a.15.15 0 01-.15.15zm-8.248-4.882v.603a.301.301 0 01-.301.301H5.932a.301.301 0 01-.301-.3v-.604c0-.166.135-.301.301-.301h5.163c.166 0 .301.135.301.301z",
    fill: "#000"
  })), _path2$e || (_path2$e = /*#__PURE__*/React.createElement("path", {
    d: "M11.396 15.949v-.603a.301.301 0 00-.301-.301H5.932a.301.301 0 00-.301.301v.603c0 .166.135.301.301.301h5.163a.301.301 0 00.301-.301zM18.409 13.337v-.603a.301.301 0 00-.302-.301h-5.163a.301.301 0 00-.301.301v.603c0 .167.135.301.301.301h5.163a.301.301 0 00.302-.3zM18.409 10.926v-.602a.301.301 0 00-.302-.302h-5.163a.301.301 0 00-.301.302v.602c0 .167.135.302.301.302h5.163a.301.301 0 00.302-.302zM18.409 8.516v-.603a.301.301 0 00-.302-.301h-5.163a.301.301 0 00-.301.301v.603c0 .166.135.301.301.301h5.163a.301.301 0 00.302-.301zM18.429 15.949v-.603a.301.301 0 00-.302-.301h-5.163a.301.301 0 00-.301.301v.603c0 .166.135.301.301.301h5.163a.301.301 0 00.302-.301zM8.408 9.165a11.24 11.24 0 01-.157-.667h-.01s-.086.423-.156.667l-.223.753h.765l-.219-.753zM6.536 11.17L7.69 7.774a.24.24 0 01.229-.162h.653c.102 0 .195.066.229.162l1.155 3.397a.242.242 0 01-.23.32h-.46a.24.24 0 01-.23-.173l-.189-.64h-1.21l-.182.638a.243.243 0 01-.231.175h-.46a.243.243 0 01-.23-.32z",
    fill: "#000"
  })));
}

var _path$1z, _path2$d;

function _extends$1G() { _extends$1G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1G.apply(this, arguments); }

function SvgHorizontalTwoColumnsBOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1G({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1z || (_path$1z = /*#__PURE__*/React.createElement("path", {
    d: "M19.795 5H4.205C3.54 5 3 5.54 3 6.205v11.411c0 .666.54 1.205 1.205 1.205h15.59c.665 0 1.205-.54 1.205-1.205V6.206C21 5.54 20.46 5 19.795 5zm-.151 12.616H4.356a.15.15 0 01-.15-.15V6.355a.15.15 0 01.15-.15h15.288a.15.15 0 01.15.15v11.11a.15.15 0 01-.15.15z",
    fill: "#000"
  })), _path2$d || (_path2$d = /*#__PURE__*/React.createElement("path", {
    d: "M15.813 9.124c-.07-.243-.156-.667-.156-.667h-.01s-.087.424-.157.667l-.223.754h.765l-.219-.754zm-1.872 2.007l1.155-3.397a.24.24 0 01.23-.163h.652c.103 0 .195.067.23.163l1.154 3.397a.242.242 0 01-.229.32h-.46a.24.24 0 01-.23-.173l-.19-.641h-1.209l-.183.639a.243.243 0 01-.23.175h-.46a.243.243 0 01-.23-.32zM7.118 12.714h-.602a.301.301 0 00-.302.302v3.234c0 .166.135.301.302.301h.602a.301.301 0 00.302-.3v-3.235a.301.301 0 00-.302-.302zM7.118 7.571h-.602a.301.301 0 00-.302.302v3.234c0 .166.135.301.302.301h.602a.301.301 0 00.302-.301V7.873a.301.301 0 00-.302-.302zM9.69 12.714h-.603a.301.301 0 00-.301.302v3.234c0 .166.135.301.301.301h.603a.301.301 0 00.301-.3v-3.235a.301.301 0 00-.301-.302zM9.69 7.571h-.603a.301.301 0 00-.301.302v3.234c0 .166.135.301.301.301h.603a.301.301 0 00.301-.301V7.873a.301.301 0 00-.301-.302zM12.261 12.714h-.602a.301.301 0 00-.302.302v3.234c0 .166.135.301.302.301h.602a.301.301 0 00.302-.3v-3.235a.301.301 0 00-.302-.302zM12.261 7.571h-.602a.301.301 0 00-.302.302v3.234c0 .166.135.301.302.301h.602a.301.301 0 00.302-.301V7.873a.301.301 0 00-.302-.302zM14.833 12.714h-.603a.301.301 0 00-.301.302v3.234c0 .166.134.301.3.301h.604a.301.301 0 00.3-.3v-3.235a.301.301 0 00-.3-.302zM17.404 12.714h-.603a.301.301 0 00-.301.302v3.234c0 .166.135.301.301.301h.603a.301.301 0 00.301-.3v-3.235a.301.301 0 00-.301-.302z",
    fill: "#000"
  })));
}

var _path$1y;

function _extends$1F() { _extends$1F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1F.apply(this, arguments); }

function SvgImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1F({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1y || (_path$1y = /*#__PURE__*/React.createElement("path", {
    d: "M20.125 19.5H3.875A1.875 1.875 0 012 17.625V6.375C2 5.339 2.84 4.5 3.875 4.5h16.25C21.16 4.5 22 5.34 22 6.375v11.25c0 1.035-.84 1.875-1.875 1.875zM6.375 6.687a2.188 2.188 0 100 4.376 2.188 2.188 0 000-4.376zM4.5 17h15v-4.375l-3.419-3.419a.469.469 0 00-.662 0L10.125 14.5l-2.169-2.169a.469.469 0 00-.662 0L4.5 15.125V17z",
    fill: "#000"
  })));
}

var _path$1x;

function _extends$1E() { _extends$1E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1E.apply(this, arguments); }

function SvgImageOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1E({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1x || (_path$1x = /*#__PURE__*/React.createElement("path", {
    d: "M20.125 4.5H3.875C2.839 4.5 2 5.34 2 6.375v11.25c0 1.035.84 1.875 1.875 1.875h16.25c1.035 0 1.875-.84 1.875-1.875V6.375c0-1.036-.84-1.875-1.875-1.875zm-.234 13.125H4.109a.235.235 0 01-.234-.234V6.609a.234.234 0 01.234-.234h15.782a.235.235 0 01.234.234v10.782a.235.235 0 01-.234.234zM7 7.937a1.563 1.563 0 100 3.126 1.563 1.563 0 000-3.126zM5.75 15.75h12.5v-3.125l-3.419-3.419a.469.469 0 00-.662 0L9.5 13.875l-1.544-1.544a.469.469 0 00-.662 0L5.75 13.875v1.875z",
    fill: "#000"
  })));
}

var _path$1w;

function _extends$1D() { _extends$1D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1D.apply(this, arguments); }

function SvgImageSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1D({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1w || (_path$1w = /*#__PURE__*/React.createElement("path", {
    d: "M20.125 19.5H3.875A1.875 1.875 0 012 17.625V6.375C2 5.339 2.84 4.5 3.875 4.5h16.25C21.16 4.5 22 5.34 22 6.375v11.25c0 1.035-.84 1.875-1.875 1.875zM6.375 6.687a2.188 2.188 0 100 4.376 2.188 2.188 0 000-4.376zM4.5 17h15v-4.375l-3.419-3.419a.469.469 0 00-.662 0L10.125 14.5l-2.169-2.169a.469.469 0 00-.662 0L4.5 15.125V17z",
    fill: "#000"
  })));
}

var _path$1v;

function _extends$1C() { _extends$1C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1C.apply(this, arguments); }

function SvgInfoSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1C({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1v || (_path$1v = /*#__PURE__*/React.createElement("path", {
    d: "M9.031 18.571h.781V12.93h-.78a.781.781 0 01-.782-.782v-1.866c0-.431.35-.781.781-.781h4.375c.432 0 .781.35.781.781v8.29h.782c.431 0 .781.35.781.782v1.866c0 .431-.35.781-.781.781H9.03a.781.781 0 01-.781-.781v-1.866c0-.432.35-.782.781-.782zM12 2a2.812 2.812 0 100 5.625A2.812 2.812 0 0012 2z",
    fill: "#D5D7DE"
  })));
}

var _path$1u, _path2$c;

function _extends$1B() { _extends$1B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1B.apply(this, arguments); }

function SvgIntroductionSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1B({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1u || (_path$1u = /*#__PURE__*/React.createElement("path", {
    d: "M20.333 4H3.667C2.747 4 2 4.747 2 5.667v12.222c0 .92.747 1.667 1.667 1.667h16.666c.92 0 1.667-.747 1.667-1.667V5.667C22 4.747 21.253 4 20.333 4zm0 13.778H12.5 12 8.5 3.667v-9.89h16.666v9.89zM14.5 15.11h3.889a.279.279 0 00.278-.278v-.555a.279.279 0 00-.278-.278H14.5a.279.279 0 00-.278.278v.555c0 .153.125.278.278.278zm0-2.222h3.889a.279.279 0 00.278-.278v-.555a.279.279 0 00-.278-.278H14.5a.279.279 0 00-.278.278v.555c0 .153.125.278.278.278zm0-2.222h3.889a.279.279 0 00.278-.278v-.556a.279.279 0 00-.278-.277H14.5a.279.279 0 00-.278.277v.556c0 .153.125.278.278.278z",
    fill: "#000"
  })), _path2$c || (_path2$c = /*#__PURE__*/React.createElement("path", {
    d: "M10.464 9.5H6.536c-.296 0-.536.288-.536.643v4.571c0 .355.24.643.536.643h3.928c.296 0 .536-.288.536-.643v-4.571c0-.355-.24-.643-.536-.643z",
    fill: "#000"
  })));
}

var _path$1t;

function _extends$1A() { _extends$1A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1A.apply(this, arguments); }

function SvgItalicSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1A({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1t || (_path$1t = /*#__PURE__*/React.createElement("path", {
    d: "M19.143 2.714v1.429a.714.714 0 01-.714.714h-2.802l-3.572 14.286h2.088a.714.714 0 01.714.714v1.429a.715.715 0 01-.714.714H5.57a.714.714 0 01-.714-.714v-1.429a.714.714 0 01.714-.714h2.802l3.572-14.286H9.857a.714.714 0 01-.714-.714V2.714A.714.714 0 019.857 2h8.572a.714.714 0 01.714.714z",
    fill: "#000"
  })));
}

var _path$1s;

function _extends$1z() { _extends$1z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1z.apply(this, arguments); }

function SvgLightRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1z({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1s || (_path$1s = /*#__PURE__*/React.createElement("path", {
    d: "M6.8 6h4v4H10V7.2A5.185 5.185 0 006.8 12a5.2 5.2 0 0010.4 0 5.202 5.202 0 00-4-5.064v-.824A6.01 6.01 0 0118 12c0 3.304-2.688 6-6 6a6 6 0 01-6-6c0-2.224 1.2-4.16 2.992-5.2H6.8V6z",
    fill: "#444E60"
  })));
}

var _path$1r;

function _extends$1y() { _extends$1y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1y.apply(this, arguments); }

function SvgLightbulbSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1y({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1r || (_path$1r = /*#__PURE__*/React.createElement("path", {
    d: "M8.877 19.748c0 .245.073.486.21.69l.667 1.004a1.25 1.25 0 001.04.558h2.411a1.25 1.25 0 001.041-.558l.668-1.003a1.25 1.25 0 00.209-.691l.002-1.498h-6.25l.002 1.498zM5.125 8.875c0 1.733.643 3.314 1.702 4.522.645.737 1.654 2.275 2.04 3.573l.003.03h6.26l.004-.03c.385-1.298 1.394-2.836 2.04-3.573a6.836 6.836 0 001.7-4.522A6.875 6.875 0 0011.98 2c-3.985.012-6.854 3.241-6.854 6.875zM12 5.75a3.129 3.129 0 00-3.125 3.125.625.625 0 11-1.25 0A4.38 4.38 0 0112 4.5a.625.625 0 110 1.25z",
    fill: "#000"
  })));
}

var _path$1q;

function _extends$1x() { _extends$1x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1x.apply(this, arguments); }

function SvgLineSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1x({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1q || (_path$1q = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12.25c0 .69-.56 1.25-1.25 1.25H3.25a1.25 1.25 0 110-2.5h17.5c.69 0 1.25.56 1.25 1.25z",
    fill: "#000"
  })));
}

var _path$1p;

function _extends$1w() { _extends$1w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1w.apply(this, arguments); }

function SvgLockOpenSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1w({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1p || (_path$1p = /*#__PURE__*/React.createElement("path", {
    d: "M16.705 3.111c-2.917.01-5.26 2.413-5.26 5.33v2.448H3.666c-.92 0-1.667.746-1.667 1.667v6.666c0 .92.747 1.667 1.667 1.667h12.222c.92 0 1.667-.747 1.667-1.667v-6.666c0-.92-.747-1.667-1.667-1.667h-1.667V8.42c0-1.375 1.1-2.517 2.476-2.531a2.504 2.504 0 012.524 2.5v2.778c0 .462.372.833.834.833h1.11a.831.831 0 00.834-.833V8.389a5.284 5.284 0 00-5.295-5.278z",
    fill: "#000"
  })));
}

var _path$1o;

function _extends$1v() { _extends$1v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1v.apply(this, arguments); }

function SvgLockSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1v({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1o || (_path$1o = /*#__PURE__*/React.createElement("path", {
    d: "M18.875 10.75h-.938V7.937A5.945 5.945 0 0012 2a5.945 5.945 0 00-5.938 5.938v2.812h-.937c-1.035 0-1.875.84-1.875 1.875v7.5C3.25 21.16 4.09 22 5.125 22h13.75c1.035 0 1.875-.84 1.875-1.875v-7.5c0-1.035-.84-1.875-1.875-1.875zm-4.063 0H9.189V7.937A2.816 2.816 0 0112 5.126a2.816 2.816 0 012.813 2.813v2.812z",
    fill: "#000"
  })));
}

var _path$1n;

function _extends$1u() { _extends$1u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1u.apply(this, arguments); }

function SvgLongArrowRightSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1u({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1n || (_path$1n = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.429 7.37l4.205 4.239c.488.492.488 1.29 0 1.782l-4.205 4.24a1.243 1.243 0 01-1.768 0 1.268 1.268 0 010-1.783l2.071-2.088H3.25c-.69 0-1.25-.564-1.25-1.26 0-.696.56-1.26 1.25-1.26h14.482l-2.07-2.088a1.268 1.268 0 010-1.783 1.243 1.243 0 011.767 0z",
    fill: "#000"
  })));
}

var _path$1m;

function _extends$1t() { _extends$1t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1t.apply(this, arguments); }

function SvgMarkerSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1t({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1m || (_path$1m = /*#__PURE__*/React.createElement("path", {
    d: "M5.67 13.33a12.775 12.775 0 00-3.663 7.62l-.001.008a.938.938 0 001.035 1.036 12.774 12.774 0 007.63-3.664l2.945-2.945-5-5-2.946 2.944zM20.964 3.035a3.536 3.536 0 00-5 0l-.85.85-1.428-1.428c-.61-.61-1.6-.61-2.21 0L7.41 6.525a.625.625 0 000 .884l.884.884c.244.244.64.244.884 0l3.404-3.404.765.765L9.5 9.5l5.001 5 6.464-6.463a3.536 3.536 0 000-5.001z",
    fill: "#000"
  })));
}

var _path$1l;

function _extends$1s() { _extends$1s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1s.apply(this, arguments); }

function SvgMarkerpenSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1s({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1l || (_path$1l = /*#__PURE__*/React.createElement("path", {
    d: "M5.2 15.215l4.738 4.72-.824.821c-.19.19-.5.19-.69 0l-4.029-4.038a.484.484 0 01-.002-.682l.807-.82zM3.948 17.766l3.137 2.977-.642.767a.488.488 0 01-.53.149l-3.581-1.203a.484.484 0 01-.197-.795l1.813-1.895zM11.073 19.423c-.436.023-.755-.19-1.05-.486-1.328-1.333-2.664-2.658-3.998-3.983-.758-.754-.694-1.46.103-2.142 3.648-3.125 7.296-6.25 10.941-9.38.649-.556 1.303-.597 1.928.002.867.83 1.717 1.679 2.554 2.54.598.615.589 1.278.033 1.925-3.16 3.668-6.322 7.334-9.48 11.002-.274.319-.594.532-1.03.522z",
    fill: "#000"
  })));
}

var _path$1k;

function _extends$1r() { _extends$1r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1r.apply(this, arguments); }

function SvgMedalSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1r({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1k || (_path$1k = /*#__PURE__*/React.createElement("path", {
    d: "M10.74 7.107l-2.7-4.5A1.25 1.25 0 006.968 2H2.626a.625.625 0 00-.512.984l4.347 6.209a8.084 8.084 0 014.28-2.086zM21.374 2h-4.342c-.44 0-.846.23-1.072.607l-2.7 4.5c1.642.257 3.118 1.001 4.28 2.086l4.346-6.21A.625.625 0 0021.374 2zM12 8.25A6.875 6.875 0 1012 22a6.875 6.875 0 000-13.75zm3.614 6.143l-1.482 1.444.35 2.04a.449.449 0 01-.65.472L12 17.386l-1.832.963a.448.448 0 01-.65-.472l.35-2.04-1.482-1.444a.449.449 0 01.248-.765l2.048-.299.916-1.856a.442.442 0 01.401-.25c.16 0 .321.084.404.25l.915 1.856 2.048.299a.449.449 0 01.248.765z",
    fill: "#B0B7C3"
  })));
}

var _path$1j;

function _extends$1q() { _extends$1q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1q.apply(this, arguments); }

function SvgMegaphoneSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1q({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1j || (_path$1j = /*#__PURE__*/React.createElement("path", {
    d: "M17.986 17.692c0 1.157.854 2.012 2.002 2.012 1.157 0 2.012-.855 2.012-2.012V4.02C22 2.863 21.145 2 19.988 2c-1.148 0-2.002.863-2.002 2.02v13.672zm-9.088-2.448c2.6.32 5.243 1.13 7.77 2.457-.017-.098-.017-.196-.017-.303V4.305c0-.07 0-.151.009-.222-2.44 1.3-5.368 2.19-7.762 2.456v8.705zM5.881 6.54C3.37 6.54 2 7.866 2 10.287v1.21c0 2.412 1.37 3.738 3.88 3.738h1.683V6.54H5.881zm3.685 14.9c1.192 0 2.091-.925 1.744-2.332l-.578-2.394c-.614-.24-1.95-.374-3.071-.374H5.64l1.735 3.498c.507 1.024 1.06 1.602 2.19 1.602z",
    fill: "#000"
  })));
}

var _path$1i;

function _extends$1p() { _extends$1p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1p.apply(this, arguments); }

function SvgMicrophoneAltSlashSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1p({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1i || (_path$1i = /*#__PURE__*/React.createElement("path", {
    d: "M21.807 18.316l-4.924-3.806c.39-.753.617-1.604.617-2.51v-1.5a.5.5 0 00-.5-.5h-.5a.5.5 0 00-.5.5V12c0 .56-.124 1.088-.335 1.569l-.83-.642c.097-.293.165-.6.165-.927V7a3 3 0 00-6 0v1.418L3.42 4.105a.5.5 0 00-.701.088l-.614.79a.5.5 0 00.088.701l18.386 14.21a.5.5 0 00.702-.087l.614-.79a.5.5 0 00-.088-.701zM12.75 18.5h1.75a.5.5 0 01.5.5v.5a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5V19a.5.5 0 01.5-.5h1.75v-1.067c-2.751-.38-4.75-2.877-4.75-5.678v-.214l1.626 1.257c.389 1.663 1.729 3.012 3.474 3.183.205.02.402.007.6-.005.012 0 .024 0 .036-.002l1.575 1.218c-.34.119-.695.202-1.061.252V18.5z",
    fill: "#000"
  })));
}

var _path$1h, _path2$b;

function _extends$1o() { _extends$1o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1o.apply(this, arguments); }

function SvgMicrophoneAltSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1o({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1h || (_path$1h = /*#__PURE__*/React.createElement("path", {
    d: "M17 10h-.5a.5.5 0 00-.5.5V12a4.005 4.005 0 01-4.4 3.98C9.522 15.779 8 13.91 8 11.823V10.5a.5.5 0 00-.5-.5H7a.5.5 0 00-.5.5v1.255c0 2.801 2 5.298 4.75 5.678V18.5H9.5a.5.5 0 00-.5.5v.5a.5.5 0 00.5.5h5a.5.5 0 00.5-.5V19a.5.5 0 00-.5-.5h-1.75v-1.055c2.678-.368 4.75-2.667 4.75-5.445v-1.5a.5.5 0 00-.5-.5z",
    fill: "#000"
  })), _path2$b || (_path2$b = /*#__PURE__*/React.createElement("path", {
    d: "M15 12a3 3 0 11-6 0V7a3 3 0 116 0v5z",
    fill: "#000"
  })));
}

var _path$1g;

function _extends$1n() { _extends$1n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1n.apply(this, arguments); }

function SvgMinusSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1n({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1g || (_path$1g = /*#__PURE__*/React.createElement("path", {
    d: "M20.571 9.857H3.43c-.79 0-1.429.64-1.429 1.429v1.428c0 .79.64 1.429 1.429 1.429H20.57c.79 0 1.429-.64 1.429-1.429v-1.428c0-.79-.64-1.429-1.429-1.429z",
    fill: "#000"
  })));
}

var _circle, _circle2, _circle3;

function _extends$1m() { _extends$1m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1m.apply(this, arguments); }

function SvgMoreOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1m({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 12.5,
    r: 1.5,
    fill: "#000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.5,
    r: 1.5,
    fill: "#000"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 12.5,
    r: 1.5,
    fill: "#000"
  })));
}

var _path$1f;

function _extends$1l() { _extends$1l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1l.apply(this, arguments); }

function SvgMousePointerSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1l({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1f || (_path$1f = /*#__PURE__*/React.createElement("path", {
    d: "M17.554 14.857H13.41l2.181 5.312a.726.726 0 01-.369.937l-1.92.837a.691.691 0 01-.912-.38l-2.072-5.044-3.385 3.482c-.451.464-1.183.107-1.183-.502V2.715c0-.64.778-.953 1.183-.502l11.11 11.427c.448.437.117 1.216-.489 1.216z",
    fill: "#000"
  })));
}

var _path$1e;

function _extends$1k() { _extends$1k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1k.apply(this, arguments); }

function SvgMusicSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1k({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1e || (_path$1e = /*#__PURE__*/React.createElement("path", {
    d: "M20.374 2.058L7.875 5.75A1.25 1.25 0 007 6.941v10.212c-.41-.1-.829-.151-1.25-.154C3.68 17 2 18.12 2 19.5S3.68 22 5.75 22c2.07 0 3.75-1.12 3.75-2.5v-9.128l10-2.93v7.212c-.41-.1-.829-.151-1.25-.154-2.07 0-3.75 1.12-3.75 2.5s1.68 2.5 3.75 2.5C20.32 19.5 22 18.38 22 17V3.25a1.25 1.25 0 00-1.626-1.19z",
    fill: "#000"
  })));
}

var _path$1d;

function _extends$1j() { _extends$1j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1j.apply(this, arguments); }

function SvgOrignalsizeSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1j({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1d || (_path$1d = /*#__PURE__*/React.createElement("path", {
    d: "M3.59 11.579h5.492c1.474 0 2.332-.875 2.332-2.379V3.867c0-.907-.68-1.547-1.58-1.547-.899 0-1.579.64-1.579 1.547v.405l.23 2.101-1.454-1.557-2.28-2.347C4.458 2.16 4.051 2 3.631 2 2.66 2 2 2.715 2 3.696c0 .427.188.8.481 1.099L4.782 7.13 6.32 8.603l-2.123-.235H3.59c-.89 0-1.527.693-1.527 1.61 0 .918.627 1.6 1.527 1.6zM14.144 21.7c.9 0 1.58-.64 1.58-1.557v-.437l-.23-2.102 1.443 1.558 2.301 2.368c.304.309.712.469 1.13.469.973 0 1.632-.715 1.632-1.696 0-.427-.188-.8-.481-1.099l-2.322-2.357-1.538-1.472 2.113.235h.649c.9 0 1.527-.694 1.527-1.611s-.628-1.6-1.527-1.6h-5.523c-1.475 0-2.333.875-2.333 2.379v5.365c0 .917.68 1.557 1.58 1.557z",
    fill: "#000"
  })));
}

var _path$1c;

function _extends$1i() { _extends$1i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1i.apply(this, arguments); }

function SvgPaperPlaneSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1i({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1c || (_path$1c = /*#__PURE__*/React.createElement("path", {
    d: "M20.593 2.126L2.49 12.57a.938.938 0 00.086 1.688l4.151 1.741 11.22-9.888c.215-.192.52.101.337.324L8.876 17.896v3.144c0 .922 1.113 1.285 1.66.617l2.48-3.018 4.866 2.038a.94.94 0 001.29-.71l2.811-16.872c.133-.79-.715-1.36-1.39-.969z",
    fill: "#000"
  })));
}

var _path$1b;

function _extends$1h() { _extends$1h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1h.apply(this, arguments); }

function SvgPaperclipSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1h({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1b || (_path$1b = /*#__PURE__*/React.createElement("path", {
    d: "M4.94 20.209c-2.283-2.355-2.24-6.153.053-8.5l8.194-8.38a4.371 4.371 0 016.276 0 4.547 4.547 0 010 6.338l-7.142 7.299a2.914 2.914 0 01-4.218-.039c-1.105-1.17-1.07-3.026.057-4.178l5.614-5.736a.625.625 0 01.884-.009l.893.874c.247.242.251.637.01.884l-5.615 5.735c-.192.197-.204.525-.025.715.17.18.44.184.613.006l7.142-7.299a2.046 2.046 0 000-2.843 1.873 1.873 0 00-2.701 0l-8.194 8.38c-1.358 1.39-1.379 3.638-.047 5.013a3.331 3.331 0 004.807.011l6.721-6.875a.625.625 0 01.884-.01l.894.874a.625.625 0 01.01.884l-6.721 6.875a5.828 5.828 0 01-8.39-.02z",
    fill: "#000"
  })));
}

var _path$1a;

function _extends$1g() { _extends$1g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1g.apply(this, arguments); }

function SvgPenSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1g({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1a || (_path$1a = /*#__PURE__*/React.createElement("path", {
    d: "M13.357 5.642l5 5L7.5 21.503l-4.458.492a.938.938 0 01-1.035-1.036l.496-4.461L13.357 5.642zm8.094-.744L19.103 2.55a1.876 1.876 0 00-2.653 0l-2.209 2.209 5 5 2.21-2.209a1.876 1.876 0 000-2.652z",
    fill: "#000"
  })));
}

var _path$19;

function _extends$1f() { _extends$1f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1f.apply(this, arguments); }

function SvgPeopleArrowsSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1f({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$19 || (_path$19 = /*#__PURE__*/React.createElement("path", {
    d: "M5.333 7.444a2.222 2.222 0 100-4.444 2.222 2.222 0 000 4.444zm0 6.114a1.532 1.532 0 01.474-1.11l2.504-2.365c.058-.053.131-.08.195-.124a2.22 2.22 0 00-2.062-1.403H4.222A2.222 2.222 0 002 10.778v3.333a1.111 1.111 0 001.111 1.111v4.445a1.111 1.111 0 001.111 1.11h2.222a1.111 1.111 0 001.112-1.11V16.32l-1.75-1.65a1.53 1.53 0 01-.473-1.112zm13.334-6.114a2.222 2.222 0 100-4.444 2.222 2.222 0 000 4.444zm1.11 1.112h-2.221a2.22 2.22 0 00-2.062 1.403c.064.044.139.07.195.125l2.504 2.363a1.542 1.542 0 010 2.222l-1.749 1.651v3.347a1.111 1.111 0 001.112 1.11h2.222a1.111 1.111 0 001.11-1.11v-4.445A1.111 1.111 0 0022 14.112v-3.334a2.222 2.222 0 00-2.222-2.222zm-2.346 4.699l-2.505-2.363a.418.418 0 00-.704.302v1.25H9.778v-1.25a.417.417 0 00-.704-.303l-2.505 2.364a.43.43 0 000 .606l2.505 2.364a.416.416 0 00.704-.304v-1.254h4.444v1.255a.417.417 0 00.704.303l2.505-2.364a.43.43 0 000-.606z",
    fill: "#000"
  })));
}

var _path$18;

function _extends$1e() { _extends$1e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1e.apply(this, arguments); }

function SvgPhotoVideoSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1e({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$18 || (_path$18 = /*#__PURE__*/React.createElement("path", {
    d: "M21 4H7a1 1 0 00-1 1v3h5V6h6v10h4a1 1 0 001-1V5a1 1 0 00-1-1zM9.25 7.219a.281.281 0 01-.281.281H8.03a.281.281 0 01-.281-.281V6.28A.281.281 0 018.031 6h.938a.281.281 0 01.281.281v.938zm11 6.5a.281.281 0 01-.281.281h-.938a.281.281 0 01-.281-.281v-.938a.281.281 0 01.281-.281h.938a.281.281 0 01.281.281v.938zm0-3.25a.281.281 0 01-.281.281h-.938a.281.281 0 01-.281-.281V9.53a.281.281 0 01.281-.281h.938a.281.281 0 01.281.281v.938zm0-3.25a.281.281 0 01-.281.281h-.938a.281.281 0 01-.281-.281V6.28A.281.281 0 0119.031 6h.938a.281.281 0 01.281.281v.938zM15 9H3a1 1 0 00-1 1v9a1 1 0 001 1h12a1 1 0 001-1v-9a1 1 0 00-1-1zM5 11a1 1 0 110 2 1 1 0 010-2zm9 7H4v-1l2-2 1 1 4-4 3 3v3z",
    fill: "#C1C7D0"
  })));
}

var _path$17;

function _extends$1d() { _extends$1d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1d.apply(this, arguments); }

function SvgPlaySolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1d({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$17 || (_path$17 = /*#__PURE__*/React.createElement("path", {
    d: "M19.828 10.385L6.078 2.257c-1.117-.66-2.828-.02-2.828 1.613v16.253c0 1.465 1.59 2.348 2.829 1.613l13.749-8.124c1.227-.723 1.23-2.504 0-3.227z",
    fill: "#000"
  })));
}

var _path$16;

function _extends$1c() { _extends$1c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1c.apply(this, arguments); }

function SvgPlusCircleSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1c({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$16 || (_path$16 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.476 2 2 6.476 2 12s4.476 10 10 10 10-4.476 10-10S17.524 2 12 2zm5.806 11.129a.485.485 0 01-.483.484h-3.71v3.71a.485.485 0 01-.484.483h-2.258a.485.485 0 01-.484-.483v-3.71h-3.71a.485.485 0 01-.483-.484v-2.258c0-.266.217-.484.483-.484h3.71v-3.71c0-.266.218-.483.484-.483h2.258c.266 0 .484.217.484.483v3.71h3.71c.266 0 .483.218.483.484v2.258z",
    fill: "#000"
  })));
}

var _path$15;

function _extends$1b() { _extends$1b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1b.apply(this, arguments); }

function SvgPlusOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1b({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$15 || (_path$15 = /*#__PURE__*/React.createElement("path", {
    d: "M3.185 13.172h7.636v7.643A1.2 1.2 0 0012.006 22c.65 0 1.173-.548 1.173-1.185v-7.643h7.648C21.465 13.172 22 12.65 22 12c0-.65-.535-1.172-1.173-1.172H13.18V3.185c0-.637-.523-1.185-1.173-1.185a1.2 1.2 0 00-1.185 1.185v7.643H3.185C2.548 10.828 2 11.35 2 12c0 .65.548 1.172 1.185 1.172z",
    fill: "#000"
  })));
}

var _path$14;

function _extends$1a() { _extends$1a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1a.apply(this, arguments); }

function SvgPlusSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1a({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$14 || (_path$14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.571 9.857h-6.428V3.43c0-.79-.64-1.429-1.429-1.429h-1.428c-.79 0-1.429.64-1.429 1.429v6.428H3.43c-.79 0-1.429.64-1.429 1.429v1.428c0 .79.64 1.429 1.429 1.429h6.428v6.428c0 .79.64 1.429 1.429 1.429h1.428c.79 0 1.429-.64 1.429-1.429v-6.428h6.428c.79 0 1.429-.64 1.429-1.429v-1.428c0-.79-.64-1.429-1.429-1.429z",
    fill: "#000"
  })));
}

var _path$13;

function _extends$19() { _extends$19 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$19.apply(this, arguments); }

function SvgQaToolSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$19({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$13 || (_path$13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4.5a2 2 0 00-2 2v11a2 2 0 002 2h16a2 2 0 002-2v-11a2 2 0 00-2-2H4zm4.18 11.23l.68 1.12h2.62l-1.44-1.94c.387-.333.69-.737.91-1.21.22-.48.33-1.003.33-1.57 0-.693-.163-1.317-.49-1.87a3.383 3.383 0 00-1.31-1.29 3.65 3.65 0 00-1.83-.47c-.667 0-1.28.157-1.84.47a3.454 3.454 0 00-1.32 1.29A3.608 3.608 0 004 12.13c0 .693.163 1.317.49 1.87.327.553.767.987 1.32 1.3.56.313 1.173.47 1.84.47.2 0 .377-.013.53-.04zm-1.56-2.45c-.24-.287-.36-.67-.36-1.15 0-.487.12-.87.36-1.15.24-.287.583-.43 1.03-.43.44 0 .78.143 1.02.43.24.28.36.663.36 1.15 0 .48-.12.863-.36 1.15-.24.28-.58.42-1.02.42-.447 0-.79-.14-1.03-.42zm7.29 2.42l.35-1.07h2.36l.35 1.07h2.34l-2.58-7.08h-2.56l-2.59 7.08h2.33zm1.53-4.71l.64 1.97H14.8l.64-1.97z",
    fill: "#D5D7DE"
  })));
}

var _path$12;

function _extends$18() { _extends$18 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$18.apply(this, arguments); }

function SvgQuestionCircleOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$18({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$12 || (_path$12 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.478 2 2 6.48 2 12c0 5.524 4.478 10 10 10 5.523 0 10-4.476 10-10 0-5.52-4.477-10-10-10zm0 18.064A8.06 8.06 0 013.935 12 8.062 8.062 0 0112 3.935 8.062 8.062 0 0120.064 12 8.06 8.06 0 0112 20.064zm4.324-10.29c0 2.704-2.92 2.746-2.92 3.745v.255a.484.484 0 01-.484.484h-1.84a.484.484 0 01-.484-.484v-.349c0-1.441 1.092-2.018 1.918-2.48.708-.397 1.142-.667 1.142-1.193 0-.696-.887-1.157-1.604-1.157-.935 0-1.367.442-1.973 1.208a.484.484 0 01-.672.086l-1.122-.85a.485.485 0 01-.107-.66c.953-1.4 2.166-2.185 4.056-2.185 1.978 0 4.09 1.544 4.09 3.58zm-2.63 6.742c0 .934-.76 1.694-1.694 1.694-.934 0-1.694-.76-1.694-1.694 0-.934.76-1.693 1.694-1.693.934 0 1.694.76 1.694 1.693z",
    fill: "#000"
  })));
}

var _path$11;

function _extends$17() { _extends$17 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$17.apply(this, arguments); }

function SvgRaisehandSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$17({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$11 || (_path$11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 18.469v2.139c0 .571-.463 1.034-1.035 1.034h-1.479a.62.62 0 01-.62-.62v-2.553a.517.517 0 00-1.035 0v2.553a.62.62 0 01-.62.62H7.392a1.035 1.035 0 01-1.035-1.034V17c0-.305-.136-.592-.36-.798A12.253 12.253 0 012 7.13c0-1.192.17-2.345.486-3.435A.982.982 0 013.44 3h1.78c.793 0 1.307.87 1.07 1.628-.246.79-.38 1.63-.38 2.501 0 4.606 3.72 8.34 8.31 8.34h4.646c2.1.258 3.134 1.164 3.134 3zm-7.821-5.657c2.7 0 4.888-2.197 4.888-4.906 0-2.71-2.189-4.906-4.888-4.906-2.7 0-4.888 2.196-4.888 4.906 0 2.71 2.188 4.906 4.888 4.906z",
    fill: "#000"
  })));
}

var _path$10, _path2$a;

function _extends$16() { _extends$16 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$16.apply(this, arguments); }

function SvgRaisehandSyncSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$16({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$10 || (_path$10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.88 13.34a5.25 5.25 0 00-.354 1.903 5.25 5.25 0 001.816 3.977H5.109a.98.98 0 01-.98-.98V14.82c0-.288-.129-.56-.342-.755A11.608 11.608 0 010 5.47C0 4.34.16 3.25.46 2.216a.93.93 0 01.904-.658H3.05c.752 0 1.24.825 1.015 1.543a7.924 7.924 0 00-.36 2.37c0 4.127 3.154 7.516 7.175 7.87z",
    fill: "#000"
  })), _path2$a || (_path2$a = /*#__PURE__*/React.createElement("path", {
    d: "M16.168 6.206c0 2.567-2.073 4.648-4.63 4.648-2.558 0-4.631-2.08-4.631-4.648 0-2.567 2.073-4.647 4.63-4.647 2.558 0 4.631 2.08 4.631 4.647zM18.119 12.768A2.374 2.374 0 0014.2 13.92a.17.17 0 01-.164.13h-.809a.17.17 0 01-.166-.2 3.501 3.501 0 015.857-1.88l.504-.504a.339.339 0 01.578.24v1.892a.339.339 0 01-.339.338H17.77a.339.339 0 01-.24-.578l.59-.589zm-4.78 2.296h1.892c.301 0 .453.365.24.579l-.59.589a2.374 2.374 0 003.919-1.151.17.17 0 01.164-.13h.809a.17.17 0 01.166.2 3.501 3.501 0 01-5.857 1.88l-.504.504a.339.339 0 01-.578-.24v-1.892c0-.187.152-.338.339-.338z",
    fill: "#000"
  })));
}

var _path$$;

function _extends$15() { _extends$15 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$15.apply(this, arguments); }

function SvgRandomSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$15({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$$ || (_path$$ = /*#__PURE__*/React.createElement("path", {
    d: "M21.725 16.024a.938.938 0 010 1.326L18.6 20.475c-.586.586-1.6.175-1.6-.663V18.25h-2.296a.469.469 0 01-.343-.149l-2.756-2.953 2.083-2.232 2.062 2.209H17v-1.562c0-.837 1.013-1.25 1.6-.663l3.125 3.124zM2.47 8.875H5.75l2.062 2.209 2.083-2.232L7.14 5.899a.469.469 0 00-.343-.149H2.47A.469.469 0 002 6.219v2.187c0 .26.21.469.469.469zm14.531 0v1.562c0 .838 1.014 1.25 1.6.663l3.125-3.125a.938.938 0 000-1.325L18.6 3.525c-.587-.587-1.6-.174-1.6.663V5.75h-2.296a.469.469 0 00-.343.149L5.75 15.125H2.469a.469.469 0 00-.469.469v2.187c0 .26.21.469.469.469h4.327a.47.47 0 00.343-.149l8.611-9.226H17z",
    fill: "#000"
  })));
}

var _path$_, _path2$9;

function _extends$14() { _extends$14 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$14.apply(this, arguments); }

function SvgRecordSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$14({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$_ || (_path$_ = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20.333a8.333 8.333 0 100-16.666 8.333 8.333 0 000 16.666zM12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
    fill: "#000"
  })), _path2$9 || (_path2$9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.667 12a6.667 6.667 0 11-13.334 0 6.667 6.667 0 0113.334 0z",
    fill: "#000"
  })));
}

var _path$Z;

function _extends$13() { _extends$13 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$13.apply(this, arguments); }

function SvgRedoSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$13({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$Z || (_path$Z = /*#__PURE__*/React.createElement("path", {
    d: "M21.524 2.007h-1.88a.476.476 0 00-.476.498l.159 3.282a9.812 9.812 0 00-7.492-3.463c-5.42 0-9.839 4.423-9.835 9.842.004 5.428 4.406 9.828 9.835 9.828a9.8 9.8 0 006.59-2.535.477.477 0 00.019-.691l-1.348-1.349a.476.476 0 00-.65-.021 6.98 6.98 0 111.183-9.134l-4.027-.193a.475.475 0 00-.498.476v1.88a.476.476 0 00.476.476h7.944a.476.476 0 00.476-.476V2.482a.476.476 0 00-.476-.475z",
    fill: "#000"
  })));
}

var _path$Y, _path2$8;

function _extends$12() { _extends$12 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$12.apply(this, arguments); }

function SvgReturnOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$12({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$Y || (_path$Y = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 2h-15A2.502 2.502 0 002 4.5v11.25c0 1.379 1.121 2.5 2.5 2.5h3.75v3.281a.467.467 0 00.746.375l4.879-3.656H19.5c1.379 0 2.5-1.121 2.5-2.5V4.5C22 3.121 20.879 2 19.5 2zm.625 13.75a.627.627 0 01-.625.625h-6.25l-.5.375-2.625 1.969v-2.344H4.5a.627.627 0 01-.625-.625V4.5c0-.344.281-.625.625-.625h15c.344 0 .625.281.625.625v11.25z",
    fill: "#000"
  })), _path2$8 || (_path2$8 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13.438c0 .861-.673 1.562-1.5 1.562s-1.5-.7-1.5-1.563c0-.861.673-1.562 1.5-1.562s1.5.7 1.5 1.563zm-2.826-7.946l.255 5.313c.012.25.21.445.45.445h1.243c.24 0 .437-.196.45-.445l.254-5.313a.46.46 0 00-.45-.492h-1.753a.46.46 0 00-.45.492z",
    fill: "#000"
  })));
}

var _path$X;

function _extends$11() { _extends$11 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$11.apply(this, arguments); }

function SvgRightTriangleOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$11({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$X || (_path$X = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.97 4.67v15.36h15.36L3.97 4.67zM2 3.482c0-1.317 1.592-1.976 2.523-1.045l17.041 17.04c.931.932.272 2.524-1.045 2.524H3.479A1.478 1.478 0 012 20.522V3.482z",
    fill: "#000"
  })));
}

var _path$W;

function _extends$10() { _extends$10 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$10.apply(this, arguments); }

function SvgSchoolSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$10({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$W || (_path$W = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.969v8.5c0 .281.219.5.5.5H5v-10H3c-.563 0-1 .469-1 1zm11.25-1.5h-.75v-1.25a.269.269 0 00-.25-.25h-.5a.247.247 0 00-.25.25v2c0 .156.094.25.25.25h1.5c.125 0 .25-.094.25-.25v-.5a.269.269 0 00-.25-.25zM17.531 7.5l-5-3.344C12.375 4.031 12.187 4 12 4c-.219 0-.406.031-.563.156l-5 3.344c-.28.156-.437.469-.437.813v11.656h4v-4.5c0-.25.219-.5.5-.5h3c.25 0 .5.25.5.5v4.5h4V8.312a.932.932 0 00-.469-.812zM12 11.969a2.468 2.468 0 01-2.5-2.5c0-1.375 1.094-2.5 2.5-2.5 1.375 0 2.5 1.125 2.5 2.5 0 1.406-1.125 2.5-2.5 2.5zm9-2h-2v10h2.5c.25 0 .5-.219.5-.5v-8.5c0-.531-.469-1-1-1z",
    fill: "#000"
  })));
}

var _path$V, _path2$7;

function _extends$$() { _extends$$ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$$.apply(this, arguments); }

function SvgScoreSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$$({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$V || (_path$V = /*#__PURE__*/React.createElement("path", {
    d: "M13.673 2h-7.7s-.947 0-.947 1.08v9.863l1.351-2.567s.676-.81 1.351 0l1.487 2.837 3.107.405s.675.136.405.946l-2.432 2.297.54 3.107s.136 1.08-.945.81l-2.972-1.35-2.027.945v.54s.135 1.082 1.081 1.082h12.835s1.08.135 1.08-.946V8.215h-4.863s-1.351.27-1.351-1.216V2z",
    fill: "#000"
  })), _path2$7 || (_path2$7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.024 2v4.999h4.999s0-.54-.406-.946L15.834 2.27s-.27-.27-.81-.27zM6.648 11.997s.27-.405.405 0l1.216 2.162 2.432.405s.405.135.135.406l-1.757 1.62.406 2.433s.135.405-.406.27l-2.161-.946-2.162.946s-.344.112-.344-.293l.344-2.274L3 14.97s0-.228.135-.27l2.432-.541 1.08-2.162z",
    fill: "#000"
  })));
}

var _path$U;

function _extends$_() { _extends$_ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$_.apply(this, arguments); }

function SvgScreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$_({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$U || (_path$U = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5a2 2 0 012-2h16a2 2 0 012 2v9.881a2 2 0 01-2 2h-5.857v1.833H9.857v-1.833H4a2 2 0 01-2-2V5zm1.25 1.082a1 1 0 011-1h15.5a1 1 0 011 1v7.717a1 1 0 01-1 1H4.25a1 1 0 01-1-1V6.082zm3.036 15.49c0-.79.64-1.43 1.428-1.43h8.572c.789 0 1.428.64 1.428 1.43H6.286z",
    fill: "#000"
  })));
}

var _path$T, _path2$6;

function _extends$Z() { _extends$Z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Z.apply(this, arguments); }

function SvgSelectSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$Z({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$T || (_path$T = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.328 2C2.595 2 2 2.595 2 3.328v.713a.615.615 0 001.23 0v-.088c0-.388.316-.703.704-.703h.172a.625.625 0 100-1.25h-.778zm4.566 0a.625.625 0 100 1.25h4.212a.625.625 0 000-1.25H7.894zm8 0a.625.625 0 000 1.25h.172c.388 0 .703.315.703.703v.088a.615.615 0 101.231 0v-.713C18 2.595 17.405 2 16.672 2h-.778zM18 7.46a.615.615 0 10-1.23 0v4.08a.615.615 0 001.23 0V7.46zm0 7.5a.615.615 0 00-1.23 0v.087a.703.703 0 01-.704.703h-.172a.625.625 0 000 1.25h.778c.733 0 1.328-.595 1.328-1.328v-.713zM12.106 17a.625.625 0 000-1.25H7.894a.625.625 0 100 1.25h4.212zm-8 0a.625.625 0 100-1.25h-.172a.703.703 0 01-.703-.703v-.088a.615.615 0 00-1.231 0v.713C2 16.405 2.595 17 3.328 17h.778zM2 11.54a.615.615 0 001.23 0V7.46a.615.615 0 00-1.23 0v4.08z",
    fill: "#000"
  })), _path2$6 || (_path2$6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.615 18.082c.329 0 .526-.43.263-.687l-6.22-6.272c-.242-.257-.658-.086-.658.28v9.214c0 .344.394.537.657.28l1.884-1.912 1.161 2.77c.088.194.328.301.526.215l1.073-.451c.197-.086.285-.322.197-.515l-1.205-2.922h2.322z",
    fill: "#000"
  })));
}

var _path$S;

function _extends$Y() { _extends$Y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Y.apply(this, arguments); }

function SvgShapesSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$Y({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$S || (_path$S = /*#__PURE__*/React.createElement("path", {
    d: "M7 12a5 5 0 100 10 5 5 0 000-10zm14.804-2.143l-4.176-7.142a1.456 1.456 0 00-2.506 0l-4.177 7.142C10.39 10.81 11.085 12 12.2 12h8.352c1.114 0 1.81-1.19 1.253-2.143zM20.75 13.25H14.5a1.25 1.25 0 00-1.25 1.25v6.25A1.25 1.25 0 0014.5 22h6.25A1.25 1.25 0 0022 20.75V14.5a1.25 1.25 0 00-1.25-1.25z",
    fill: "#000"
  })));
}

var _path$R;

function _extends$X() { _extends$X = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$X.apply(this, arguments); }

function SvgShareSquareSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$X({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$R || (_path$R = /*#__PURE__*/React.createElement("path", {
    d: "M21.739 9.272l-5 4.722c-.527.498-1.406.129-1.406-.606V10.89c-5.02.033-7.137 1.219-5.721 5.95.156.52-.446.922-.868.601-1.353-1.028-2.577-2.993-2.577-4.978 0-4.998 4.083-5.99 9.166-6.018v-2.5c0-.735.88-1.103 1.406-.606l5 4.722a.834.834 0 010 1.211zm-6.406 7.003v2.392H4.223V7.556H5.99a.416.416 0 00.3-.129c.52-.54 1.12-.968 1.772-1.308.386-.201.243-.786-.193-.786H3.667C2.747 5.333 2 6.08 2 7v12.222c0 .92.746 1.667 1.667 1.667h12.222c.92 0 1.667-.746 1.667-1.667V16.14a.417.417 0 00-.556-.393c-.38.135-.788.175-1.188.117a.417.417 0 00-.479.412z",
    fill: "#000"
  })));
}

var _path$Q;

function _extends$W() { _extends$W = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$W.apply(this, arguments); }

function SvgShoePrintsSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$W({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$Q || (_path$Q = /*#__PURE__*/React.createElement("path", {
    d: "M8 9h1V5H8a2 2 0 100 4zm-6 8a2 2 0 002 2h1v-4H4a2 2 0 00-2 2zm10.546-4c-1.091 0-2.38.41-3.273 1-.775.512-1.391 1-3.273 1v4l1.798.499c.819.228 1.656.41 2.51.47 1.021.072 2.05.021 3.049-.193C16.778 19.04 18 17.413 18 16c0-2-2.63-3-5.454-3zm4.81-8.775a10.86 10.86 0 00-3.049-.194c-.853.06-1.69.243-2.51.47L10 5v4c1.881 0 2.498.488 3.273 1 .893.59 2.182 1 3.273 1C19.369 11 22 10 22 8c0-1.413-1.222-3.04-4.643-3.775z",
    fill: "#B0B7C3"
  })));
}

var _path$P;

function _extends$V() { _extends$V = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$V.apply(this, arguments); }

function SvgSignOutSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$V({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$P || (_path$P = /*#__PURE__*/React.createElement("path", {
    d: "M21.723 12.674l-6.667 6.667c-.595.595-1.627.179-1.627-.675v-3.81H8.032a.95.95 0 01-.952-.952v-3.81a.95.95 0 01.952-.952h5.397v-3.81c0-.849 1.028-1.27 1.627-.674l6.667 6.667a.96.96 0 010 1.35zM9.62 19.143v-1.588a.478.478 0 00-.476-.476H5.81c-.703 0-1.27-.567-1.27-1.27V8.19c0-.702.567-1.27 1.27-1.27h3.333a.478.478 0 00.476-.475V4.856a.478.478 0 00-.476-.476H5.81A3.81 3.81 0 002 8.19v7.62a3.81 3.81 0 003.81 3.809h3.333a.478.478 0 00.476-.476z",
    fill: "#000"
  })));
}

var _path$O;

function _extends$U() { _extends$U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$U.apply(this, arguments); }

function SvgSignalBadSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$U({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$O || (_path$O = /*#__PURE__*/React.createElement("path", {
    d: "M12.011 14.92c.666 0 1.063-.414 1.08-1.107.037-2.629.109-6.122.127-8.625 0-.675-.505-1.188-1.207-1.188-.711 0-1.215.513-1.215 1.188.027 2.494.099 5.996.135 8.625.018.693.405 1.107 1.08 1.107zM9.5 5.062C6.484 5.63 3.756 7.16 2.108 9.185c-.153.172-.144.415.027.595l1.207 1.224c.198.198.495.19.684-.018a10.466 10.466 0 015.537-3.124l-.063-2.8zm4.987.01l-.054 2.8c2.107.422 3.997 1.494 5.564 3.123.18.19.468.18.666-.009L21.86 9.78c.18-.18.18-.423.036-.595-1.665-2.016-4.366-3.574-7.409-4.114zm-.081 5.14l-.054 2.917c.801.315 1.521.819 2.07 1.404.19.207.45.19.667-.009l1.341-1.296c.171-.171.19-.405.036-.576-.927-1.108-2.377-2.017-4.06-2.44zm-4.807.009c-1.684.423-3.124 1.305-4.06 2.43-.154.171-.145.397.035.577l1.342 1.314c.216.207.504.18.711-.045a5.659 5.659 0 012.026-1.377l-.054-2.9zm2.403 9.137c.864 0 1.567-.684 1.567-1.53s-.703-1.521-1.567-1.521-1.566.675-1.566 1.521c0 .846.702 1.53 1.566 1.53z",
    fill: "#000"
  })));
}

var _path$N;

function _extends$T() { _extends$T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$T.apply(this, arguments); }

function SvgSignalGoodSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$T({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$N || (_path$N = /*#__PURE__*/React.createElement("path", {
    d: "M3.342 11.186c.19.198.495.189.684-.018 2.107-2.233 4.871-3.413 7.978-3.413 3.115 0 5.888 1.189 7.995 3.422.18.189.478.189.667-.01l1.197-1.206c.171-.18.18-.414.036-.594C19.83 6.81 15.975 5 12.004 5 8.034 5 4.17 6.81 2.108 9.367c-.153.18-.144.414.027.594l1.207 1.225zm3.575 3.538c.216.207.495.18.702-.036 1.053-1.134 2.71-1.927 4.385-1.918 1.693-.008 3.35.802 4.42 1.945.19.207.46.207.667 0l1.35-1.305a.403.403 0 00.037-.576c-1.35-1.621-3.8-2.774-6.474-2.774-2.674 0-5.123 1.153-6.474 2.774-.144.18-.135.396.036.576l1.35 1.314zm5.096 4.754c.207 0 .396-.099.747-.432l2.098-2.017c.162-.162.198-.414.054-.594-.612-.774-1.71-1.386-2.9-1.386-1.233 0-2.34.639-2.952 1.458-.109.162-.055.37.099.522l2.098 2.017c.35.324.54.432.756.432z",
    fill: "#000"
  })));
}

var _g$1, _defs$1;

function _extends$S() { _extends$S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$S.apply(this, arguments); }

function SvgSlotsSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$S({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$1 || (_g$1 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#slots_solid_svg__clip0)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 14.22h20v5.588c0 .658-.527 1.192-1.177 1.192H3.177C2.526 21 2 20.466 2 19.808V14.22zM17.05 9.699H7.03V3.493A.49.49 0 017.517 3h9.006a.53.53 0 01.528.534V9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 13.11h19.98l-1.948-4.932a1.087 1.087 0 00-.912-.699h-1.035v2.26l.568 1.13H5.327l.568-1.13V7.48H4.86a1.087 1.087 0 00-.913.7L2 13.108z"
  }))), _defs$1 || (_defs$1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "slots_solid_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 3)",
    d: "M0 0h20v18H0z"
  })))));
}

var _path$M;

function _extends$R() { _extends$R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$R.apply(this, arguments); }

function SvgSmileOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$R({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$M || (_path$M = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.476 2 2 6.476 2 12s4.476 10 10 10 10-4.476 10-10S17.524 2 12 2zm0 18.064c-4.448 0-8.065-3.616-8.065-8.064S7.552 3.935 12 3.935c4.448 0 8.064 3.617 8.064 8.065 0 4.448-3.616 8.064-8.064 8.064zm-3.226-8.71c.714 0 1.29-.576 1.29-1.29 0-.713-.576-1.29-1.29-1.29-.714 0-1.29.577-1.29 1.29 0 .714.576 1.29 1.29 1.29zm6.452 0c.713 0 1.29-.576 1.29-1.29 0-.713-.576-1.29-1.29-1.29-.714 0-1.29.577-1.29 1.29 0 .714.576 1.29 1.29 1.29zm.161 2.928A4.4 4.4 0 0112 15.871a4.387 4.387 0 01-3.387-1.589.97.97 0 00-1.363-.125.97.97 0 00-.125 1.363A6.33 6.33 0 0012 17.802a6.33 6.33 0 004.875-2.282.967.967 0 10-1.488-1.238z",
    fill: "#000"
  })));
}

var _path$L;

function _extends$Q() { _extends$Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Q.apply(this, arguments); }

function SvgSmileSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$Q({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$L || (_path$L = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.476 2 2 6.476 2 12s4.476 10 10 10 10-4.476 10-10S17.524 2 12 2zm3.226 6.774a1.289 1.289 0 110 2.58c-.714 0-1.29-.576-1.29-1.29 0-.713.576-1.29 1.29-1.29zm-6.452 0c.714 0 1.29.577 1.29 1.29 0 .714-.576 1.29-1.29 1.29-.714 0-1.29-.576-1.29-1.29 0-.713.576-1.29 1.29-1.29zm7.855 6.863A6.007 6.007 0 0112 17.807c-1.794 0-3.48-.79-4.629-2.17-.548-.657.444-1.48.992-.827A4.712 4.712 0 0012 16.512a4.725 4.725 0 003.637-1.702c.54-.653 1.536.17.992.827z",
    fill: "#000"
  })));
}

var _path$K;

function _extends$P() { _extends$P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$P.apply(this, arguments); }

function SvgSpeaker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$P({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$K || (_path$K = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4a3 3 0 00-3 3v11a2 2 0 002 2h5a2 2 0 002-2V7a3 3 0 00-3-3H5zm1.5 7a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm0-1.25a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zM10 15.5a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0zm-5.95 0a2.45 2.45 0 104.9 0 2.45 2.45 0 00-4.9 0zM6.5 17a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM16 4a3 3 0 00-3 3v11a2 2 0 002 2h5a2 2 0 002-2V7a3 3 0 00-3-3h-3zm1.5 7a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm0-1.25a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zM21 15.5a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0zm-5.95 0a2.45 2.45 0 104.9 0 2.45 2.45 0 00-4.9 0zM17.5 17a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
    fill: "#000"
  })));
}

var _path$J;

function _extends$O() { _extends$O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$O.apply(this, arguments); }

function SvgSpeakerBluetooth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$O({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$J || (_path$J = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.241 2H6.483v1.38H9.24V2zM2.345 6.069a2 2 0 012-2h15.31a2 2 0 012 2V20a2 2 0 01-2 2H4.345a2 2 0 01-2-2V6.069zm1.38.38a1 1 0 011-1h14.55a1 1 0 011 1v.758a1 1 0 01-1 1H4.726a1 1 0 01-1-1v-.759zm1 3.137a1 1 0 00-1 1v8.345a1 1 0 001 1h14.55a1 1 0 001-1v-8.345a1 1 0 00-1-1H4.726zm7.108 1.412a.44.44 0 01.42.047l2.364 1.725a.33.33 0 01.142.264.33.33 0 01-.142.265l-2.001 1.46 2 1.459a.33.33 0 01.143.265.33.33 0 01-.142.265l-2.365 1.724a.44.44 0 01-.42.047.345.345 0 01-.226-.312v-2.712l-1.718 1.253a.434.434 0 01-.555-.045c-.14-.146-.117-.363.05-.485l2.001-1.46-2-1.459c-.168-.122-.19-.339-.051-.485a.434.434 0 01.555-.044l1.718 1.252V11.31c0-.133.088-.255.227-.312zm.561 4.497l1.355.988-1.355.988v-1.976zm0-1.473v-1.976l1.355.988-1.355.988zM10.621 2h2.758v1.38h-2.758V2zm6.896 0H14.76v1.38h2.758V2z",
    fill: "#000"
  })));
}

var _rect$3, _rect2$2, _rect3$2;

function _extends$N() { _extends$N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$N.apply(this, arguments); }

function SvgSpeakingNoneSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$N({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$3 || (_rect$3 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 10,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#000"
  })), _rect2$2 || (_rect2$2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#000"
  })), _rect3$2 || (_rect3$2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 10,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#000"
  })));
}

var _rect$2, _rect2$1, _rect3$1;

function _extends$M() { _extends$M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$M.apply(this, arguments); }

function SvgSpeakingStrongSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$M({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$2 || (_rect$2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 9,
    width: 4,
    height: 6,
    rx: 2,
    fill: "#000"
  })), _rect2$1 || (_rect2$1 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6,
    width: 4,
    height: 12,
    rx: 2,
    fill: "#000"
  })), _rect3$1 || (_rect3$1 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 9,
    width: 4,
    height: 6,
    rx: 2,
    fill: "#000"
  })));
}

var _rect$1, _rect2, _rect3;

function _extends$L() { _extends$L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$L.apply(this, arguments); }

function SvgSpeakingWeakSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$L({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$1 || (_rect$1 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 9,
    width: 4,
    height: 6,
    rx: 2,
    fill: "#000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 8,
    width: 4,
    height: 8,
    rx: 2,
    fill: "#000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 9,
    width: 4,
    height: 6,
    rx: 2,
    fill: "#000"
  })));
}

var _mask, _rect;

function _extends$K() { _extends$K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$K.apply(this, arguments); }

function SvgSquareOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$K({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "square_outline_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 1,
    stroke: "#000",
    strokeWidth: 4,
    mask: "url(#square_outline_svg__a)"
  })));
}

var _path$I;

function _extends$J() { _extends$J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$J.apply(this, arguments); }

function SvgStarOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$J({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$I || (_path$I = /*#__PURE__*/React.createElement("path", {
    d: "M11.636 4.013L12 3.282l.364.731.709-.352m-1.437.352l3.351 5.275-.18-.363-1.912-3.843-.53-1.067.708-.354m-1.437.352l-.709-.352.709.353h0zm1.437-.352c-.438-.876-1.705-.887-2.146 0L8.486 8.574m4.587-4.913l2.441 4.913H8.486m6.248.677l-.116-.232-1.91-3.844-.53-1.067s0 0 0 0a.18.18 0 00-.07-.08.219.219 0 00-.11-.028.178.178 0 00-.176.106l2.912 5.145zm0 0l-.266-.038-.143.99.896-.446-.487-.506zm-6.248-.677l-5.462.79c-.98.14-1.372 1.34-.661 2.026l6.123-2.816z",
    stroke: "#000",
    strokeWidth: 2
  })));
}

var _path$H;

function _extends$I() { _extends$I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$I.apply(this, arguments); }

function SvgStarSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$I({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$H || (_path$H = /*#__PURE__*/React.createElement("path", {
    d: "M10.927 3.095l-2.441 4.95-5.462.795c-.98.142-1.372 1.35-.661 2.042l3.951 3.85-.935 5.44c-.168.982.868 1.719 1.735 1.259L12 18.863l4.886 2.568c.867.456 1.903-.277 1.735-1.26l-.935-5.439 3.951-3.85c.71-.692.318-1.9-.661-2.042l-5.462-.796-2.441-4.95c-.438-.882-1.705-.893-2.146 0z",
    fill: "#B0B7C3"
  })));
}

var _path$G;

function _extends$H() { _extends$H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$H.apply(this, arguments); }

function SvgStickynoteOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$H({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$G || (_path$G = /*#__PURE__*/React.createElement("path", {
    d: "M21 15.737V4.929C21 3.884 20.116 3 19.071 3H4.93A1.929 1.929 0 003 4.929V19.07C3 20.156 3.844 21 4.929 21h10.767c.523 0 1.005-.2 1.367-.563l3.334-3.334c.362-.362.603-.844.603-1.366zm-5.143 3.214v-3.094h3.054l-3.054 3.094zm3.214-14.022v9h-4.178a.952.952 0 00-.964.964v4.178h-9V4.93H19.07z",
    fill: "#000"
  })));
}

var _path$F;

function _extends$G() { _extends$G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$G.apply(this, arguments); }

function SvgStopCircleSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$G({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$F || (_path$F = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.476 2 2 6.476 2 12s4.476 10 10 10 10-4.476 10-10S17.524 2 12 2zm3.871 13.226c0 .355-.29.645-.645.645H8.774a.647.647 0 01-.645-.645V8.774c0-.355.29-.645.645-.645h6.452c.355 0 .645.29.645.645v6.452z",
    fill: "#000"
  })));
}

var _path$E;

function _extends$F() { _extends$F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$F.apply(this, arguments); }

function SvgStopRecordSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$F({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$E || (_path$E = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.476 2 2 6.476 2 12s4.476 10 10 10 10-4.476 10-10S17.524 2 12 2zm3.871 13.226c0 .355-.29.645-.645.645H8.774a.647.647 0 01-.645-.645V8.774c0-.355.29-.645.645-.645h6.452c.355 0 .645.29.645.645v6.452z",
    fill: "#000"
  })));
}

var _path$D;

function _extends$E() { _extends$E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$E.apply(this, arguments); }

function SvgStopwatchSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$E({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$D || (_path$D = /*#__PURE__*/React.createElement("path", {
    d: "M20.125 13.875A8.124 8.124 0 0111.999 22a8.124 8.124 0 01-8.124-8.125c0-4.063 2.98-7.43 6.874-8.027V4.5H9.656a.47.47 0 01-.469-.469V2.47A.47.47 0 019.656 2h4.687a.47.47 0 01.469.469V4.03a.47.47 0 01-.469.469H13.25v1.348c1.465.226 2.801.843 3.895 1.742l1.074-1.074a.47.47 0 01.664 0l1.106 1.105a.47.47 0 010 .664l-1.149 1.149-.023.023a8.044 8.044 0 011.309 4.418zm-6.876 1.406V9.363a.47.47 0 00-.468-.468h-1.563a.47.47 0 00-.469.468v5.918c0 .258.211.469.47.469h1.562a.47.47 0 00.468-.469z",
    fill: "#000"
  })));
}

var _path$C, _path2$5, _path3$1, _path4$1, _path5$1;

function _extends$D() { _extends$D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$D.apply(this, arguments); }

function SvgStraightOneColumnsOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$D({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$C || (_path$C = /*#__PURE__*/React.createElement("path", {
    d: "M16.551 11.337v.603a.301.301 0 01-.301.301H7.551a.301.301 0 01-.301-.301v-.603c0-.166.135-.301.301-.301h8.699c.166 0 .301.135.301.301zm0-2.41v.602a.301.301 0 01-.301.301h-3.877a.301.301 0 01-.302-.3v-.604c0-.166.135-.3.302-.3h3.877c.166 0 .301.134.301.3zm0-2.411v.602a.301.301 0 01-.301.302h-3.877a.301.301 0 01-.302-.302v-.602c0-.167.135-.302.302-.302h3.877c.166 0 .301.135.301.302zM16.551 14.551v-.602a.301.301 0 00-.301-.302H7.551a.301.301 0 00-.301.302v.602c0 .167.135.302.301.302h8.699a.301.301 0 00.301-.302zM9.765 7.826c-.07-.244-.157-.667-.157-.667h-.01s-.086.423-.156.667l-.223.753h.765l-.219-.753zM7.893 9.832l1.155-3.397a.24.24 0 01.229-.162h.653c.102 0 .195.066.229.162l1.155 3.397a.242.242 0 01-.229.32h-.46a.242.242 0 01-.231-.173l-.189-.64h-1.21l-.182.638a.243.243 0 01-.231.175h-.46a.243.243 0 01-.23-.32zM16.551 17.14v-.602a.301.301 0 00-.301-.301H7.571a.301.301 0 00-.3.301v.603c0 .166.134.301.3.301h8.679a.301.301 0 00.301-.301z",
    fill: "#000"
  })), _path2$5 || (_path2$5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.551 17.14v-.602a.301.301 0 00-.301-.301H7.571a.301.301 0 00-.3.301v.603c0 .166.134.301.3.301h8.679a.301.301 0 00.301-.301z",
    fill: "#000"
  })), _path3$1 || (_path3$1 = /*#__PURE__*/React.createElement("path", {
    d: "M16.551 17.14v-.602a.301.301 0 00-.301-.301H7.571a.301.301 0 00-.3.301v.603c0 .166.134.301.3.301h8.679a.301.301 0 00.301-.301z",
    fill: "#000"
  })), _path4$1 || (_path4$1 = /*#__PURE__*/React.createElement("path", {
    d: "M16.551 17.14v-.602a.301.301 0 00-.301-.301H7.571a.301.301 0 00-.3.301v.603c0 .166.134.301.3.301h8.679a.301.301 0 00.301-.301z",
    fill: "#000"
  })), _path5$1 || (_path5$1 = /*#__PURE__*/React.createElement("path", {
    d: "M18.821 19.795V4.205c0-.665-.54-1.205-1.205-1.205H6.206C5.54 3 5 3.54 5 4.205v15.59C5 20.46 5.54 21 6.205 21h11.411c.666 0 1.205-.54 1.205-1.205zm-12.616-.151V4.356a.15.15 0 01.151-.15h11.11a.15.15 0 01.15.15v15.288a.15.15 0 01-.15.15H6.355a.15.15 0 01-.15-.15z",
    fill: "#000"
  })));
}

var _path$B, _path2$4, _path3, _path4, _path5;

function _extends$C() { _extends$C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$C.apply(this, arguments); }

function SvgStraightTwoColumnsOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$C({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$B || (_path$B = /*#__PURE__*/React.createElement("path", {
    d: "M11.429 11.337v.603a.301.301 0 01-.302.301H7.551a.301.301 0 01-.301-.301v-.603c0-.166.135-.301.301-.301h3.576c.167 0 .302.135.302.301zm5.122-2.41v.602a.301.301 0 01-.301.301h-3.234a.301.301 0 01-.302-.3v-.604c0-.166.135-.3.302-.3h3.234c.166 0 .301.134.301.3zm0-2.411v.602a.301.301 0 01-.301.302h-3.234a.301.301 0 01-.302-.302v-.602c0-.167.135-.302.302-.302h3.234c.166 0 .301.135.301.302zM11.429 14.551v-.602a.301.301 0 00-.302-.302H7.551a.301.301 0 00-.301.302v.602c0 .167.135.302.301.302h3.576a.301.301 0 00.302-.302zM9.558 7.826c-.07-.244-.156-.667-.156-.667h-.01s-.087.423-.157.667l-.223.753h.765l-.219-.753zM7.686 9.832L8.84 6.435a.24.24 0 01.23-.162h.652c.102 0 .195.066.229.162l1.155 3.397a.242.242 0 01-.229.32h-.46a.242.242 0 01-.23-.173l-.19-.64h-1.21l-.182.638a.243.243 0 01-.231.175h-.46a.243.243 0 01-.23-.32zM11.409 17.14v-.602a.301.301 0 00-.302-.301H7.571a.301.301 0 00-.3.301v.603c0 .166.134.301.3.301h3.536a.301.301 0 00.302-.301z",
    fill: "#000"
  })), _path2$4 || (_path2$4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.409 17.14v-.602a.301.301 0 00-.302-.301H7.571a.301.301 0 00-.3.301v.603c0 .166.134.301.3.301h3.536a.301.301 0 00.302-.301z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.409 17.14v-.602a.301.301 0 00-.302-.301H7.571a.301.301 0 00-.3.301v.603c0 .166.134.301.3.301h3.536a.301.301 0 00.302-.301z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.409 17.14v-.602a.301.301 0 00-.302-.301H7.571a.301.301 0 00-.3.301v.603c0 .166.134.301.3.301h3.536a.301.301 0 00.302-.301zM16.551 11.94v-.603a.301.301 0 00-.301-.301h-3.234a.301.301 0 00-.302.301v.603c0 .166.135.301.302.301h3.234a.301.301 0 00.301-.301zM16.551 14.551v-.602a.301.301 0 00-.301-.302h-3.234a.301.301 0 00-.302.302v.602c0 .167.135.302.302.302h3.234a.301.301 0 00.301-.302zM16.551 17.14v-.602a.301.301 0 00-.301-.301h-3.234a.301.301 0 00-.302.301v.603c0 .166.135.301.302.301h3.234a.301.301 0 00.301-.301z",
    fill: "#000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.821 19.795V4.205c0-.665-.54-1.205-1.205-1.205H6.206C5.54 3 5 3.54 5 4.205v15.59C5 20.46 5.54 21 6.205 21h11.411c.666 0 1.205-.54 1.205-1.205zm-12.616-.151V4.356a.15.15 0 01.151-.15h11.11a.15.15 0 01.15.15v15.288a.15.15 0 01-.15.15H6.355a.15.15 0 01-.15-.15z",
    fill: "#000"
  })));
}

var _path$A;

function _extends$B() { _extends$B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }

function SvgTabletAltSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$B({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$A || (_path$A = /*#__PURE__*/React.createElement("path", {
    d: "M18.875 2H5.125C4.09 2 3.25 2.84 3.25 3.875v16.25C3.25 21.16 4.09 22 5.125 22h13.75c1.035 0 1.875-.84 1.875-1.875V3.875C20.75 2.84 19.91 2 18.875 2zM12 20.75c-.691 0-1.25-.559-1.25-1.25s.559-1.25 1.25-1.25 1.25.559 1.25 1.25-.559 1.25-1.25 1.25zm6.875-4.219a.47.47 0 01-.469.469H5.594a.47.47 0 01-.469-.469V4.344a.47.47 0 01.469-.469h12.812a.47.47 0 01.469.469V16.53z",
    fill: "#000"
  })));
}

var _path$z;

function _extends$A() { _extends$A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }

function SvgTextSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$A({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$z || (_path$z = /*#__PURE__*/React.createElement("path", {
    d: "M7.15 22v-1.252c2.055 0 3.082-.834 3.082-2.504V4.772c0-.596-.405-.894-1.215-.894-.612 0-1.146.11-1.6.328-.435.198-.82.506-1.156.924-.317.417-.593.944-.83 1.58a17.674 17.674 0 00-.593 2.175L3 8.617 3.83 2c.514.08 1.077.14 1.69.179.612.04 1.096.06 1.452.06H18.68c.435 0 .968-.02 1.6-.06.633-.04 1.206-.1 1.72-.179v6.528l-1.72.149c-.098-1.57-.434-2.743-1.007-3.518-.553-.774-1.522-1.162-2.905-1.162-.85 0-1.274.258-1.274.775v13.472c0 1.67 1.047 2.504 3.142 2.504V22H7.15z",
    fill: "#000"
  })));
}

var _path$y;

function _extends$z() { _extends$z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); }

function SvgThSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$z({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$y || (_path$y = /*#__PURE__*/React.createElement("path", {
    d: "M7.833 4.188v3.125c0 .517-.42.937-.937.937H2.938A.937.937 0 012 7.312V4.188c0-.517.42-.937.938-.937h3.958c.518 0 .937.42.937.938zm7.084 9.375v-3.126a.937.937 0 00-.938-.937h-3.958a.937.937 0 00-.938.938v3.124c0 .518.42.938.938.938h3.958c.518 0 .938-.42.938-.938zm1.25-9.376v3.125c0 .518.42.938.937.938h3.959c.517 0 .937-.42.937-.938V4.188a.937.937 0 00-.938-.937h-3.958a.937.937 0 00-.937.938zm-1.25 3.125V4.188a.937.937 0 00-.938-.937h-3.958a.937.937 0 00-.938.938v3.125c0 .517.42.937.938.937h3.958c.518 0 .938-.42.938-.938zM6.896 9.5H2.938a.937.937 0 00-.938.938v3.124c0 .518.42.938.938.938h3.958c.518 0 .937-.42.937-.938v-3.124a.937.937 0 00-.937-.938zM2 16.688v3.125c0 .517.42.937.938.937h3.958c.518 0 .937-.42.937-.938v-3.125a.937.937 0 00-.937-.937H2.938a.937.937 0 00-.938.938zM17.104 14.5h3.959c.517 0 .937-.42.937-.938v-3.124a.937.937 0 00-.938-.938h-3.958a.937.937 0 00-.937.938v3.124c0 .518.42.938.937.938zm0 6.25h3.959c.517 0 .937-.42.937-.938v-3.125a.937.937 0 00-.938-.937h-3.958a.937.937 0 00-.937.938v3.125c0 .517.42.937.937.937zm-8.02-4.063v3.125c0 .518.42.938.937.938h3.958c.518 0 .938-.42.938-.938v-3.125a.937.937 0 00-.938-.937h-3.958a.937.937 0 00-.938.938z",
    fill: "#B0B7C3"
  })));
}

var _path$x;

function _extends$y() { _extends$y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }

function SvgThumbsUpOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$y({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$x || (_path$x = /*#__PURE__*/React.createElement("path", {
    d: "M20.839 13.199c.342-.58.536-1.199.536-1.947 0-1.72-1.454-3.343-3.352-3.343h-1.425a4.99 4.99 0 00.345-1.818C16.943 3.247 15.471 2 13.222 2c-2.407 0-2.27 3.708-2.803 4.242C9.53 7.131 8.48 8.838 7.733 9.5H3.875c-.69 0-1.25.56-1.25 1.25v9.375c0 .69.56 1.25 1.25 1.25h2.5a1.25 1.25 0 001.21-.936c1.739.04 2.932 1.56 6.946 1.56l.867.001c3.013 0 4.375-1.54 4.412-3.724.52-.72.793-1.684.678-2.617.384-.72.533-1.575.35-2.46zm-2.412 2.103c.49.825.049 1.93-.545 2.248.3 1.906-.688 2.575-2.075 2.575H14.33c-2.799 0-4.61-1.478-6.705-1.478v-7.272h.427c1.107 0 2.655-2.77 3.693-3.807 1.107-1.108.738-2.954 1.477-3.693 1.846 0 1.846 1.288 1.846 2.216 0 1.53-1.107 2.216-1.107 3.693h4.062c.824 0 1.474.739 1.477 1.477.003.739-.5 1.477-.87 1.477.527.569.64 1.767-.203 2.564zM6.063 18.875a.937.937 0 11-1.875 0 .937.937 0 011.875 0z",
    fill: "#000"
  })));
}

var _path$w;

function _extends$x() { _extends$x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }

function SvgThumbsUpSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$x({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$w || (_path$w = /*#__PURE__*/React.createElement("path", {
    d: "M6.063 10.75H2.938a.937.937 0 00-.938.938v9.374c0 .518.42.938.938.938h3.124c.518 0 .938-.42.938-.938v-9.375a.937.937 0 00-.938-.937zM4.5 20.438a.937.937 0 110-1.875.937.937 0 010 1.875zM17 5.181c0 1.657-1.014 2.586-1.3 3.693h3.974c1.304 0 2.32 1.084 2.326 2.27.003.7-.295 1.455-.76 1.921l-.004.004c.384.912.322 2.19-.363 3.105.339 1.011-.003 2.254-.64 2.92.168.687.087 1.272-.24 1.743C19.195 21.984 17.219 22 15.548 22h-.11c-1.887 0-3.43-.688-4.671-1.24-.623-.277-1.438-.62-2.057-.631a.469.469 0 01-.46-.469v-8.35c0-.125.05-.245.139-.333 1.547-1.53 2.213-3.148 3.481-4.419.578-.579.789-1.454.992-2.3.174-.723.537-2.258 1.325-2.258C15.126 2 17 2.313 17 5.182z",
    fill: "#000"
  })));
}

var _path$v;

function _extends$w() { _extends$w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }

function SvgThumbtackSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$w({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$v || (_path$v = /*#__PURE__*/React.createElement("path", {
    d: "M16.142 10.37l-.478-4.62h1.649c.517 0 .937-.42.937-.938V2.938A.937.937 0 0017.312 2H6.688a.937.937 0 00-.937.938v1.874c0 .518.42.938.938.938h1.648l-.478 4.62c-1.895.88-3.358 2.46-3.358 4.443 0 .517.42.937.938.937h5.312v4.063c0 .048.011.096.033.14l.938 1.875c.114.23.443.23.559 0l.937-1.875a.312.312 0 00.033-.14V15.75h5.313c.517 0 .937-.42.937-.938 0-1.999-1.484-3.57-3.358-4.442z",
    fill: "#B0B7C3"
  })));
}

var _path$u;

function _extends$v() { _extends$v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }

function SvgToolboxSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$v({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$u || (_path$u = /*#__PURE__*/React.createElement("path", {
    d: "M21.634 10.384l-1.768-1.768a1.25 1.25 0 00-.884-.366H17V5.125c0-1.036-.84-1.875-1.875-1.875h-6.25C7.839 3.25 7 4.09 7 5.125V8.25H5.018c-.332 0-.65.132-.884.366l-1.768 1.768a1.25 1.25 0 00-.366.884V14.5h5v-.625c0-.345.28-.625.625-.625h1.25c.345 0 .625.28.625.625v.625h5v-.625c0-.345.28-.625.625-.625h1.25c.345 0 .625.28.625.625v.625h5v-3.232c0-.332-.132-.65-.366-.884zM14.5 8.25h-5v-2.5h5v2.5zm2.5 8.125c0 .345-.28.625-.625.625h-1.25a.625.625 0 01-.625-.625v-.625h-5v.625c0 .345-.28.625-.625.625h-1.25A.625.625 0 017 16.375v-.625H2v3.75c0 .69.56 1.25 1.25 1.25h17.5c.69 0 1.25-.56 1.25-1.25v-3.75h-5v.625z",
    fill: "#B0B7C3"
  })));
}

var _path$t;

function _extends$u() { _extends$u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }

function SvgTrashSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$u({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$t || (_path$t = /*#__PURE__*/React.createElement("path", {
    d: "M20.125 3.25h-4.688l-.367-.73a.938.938 0 00-.84-.52H9.766a.927.927 0 00-.836.52l-.367.73H3.875a.625.625 0 00-.625.625v1.25a.625.625 0 00.625.625h16.25a.625.625 0 00.625-.625v-1.25a.625.625 0 00-.625-.625zM5.328 20.242A1.875 1.875 0 007.2 22h9.602a1.875 1.875 0 001.87-1.758L19.5 7h-15l.828 13.242z",
    fill: "#000"
  })));
}

var _path$s;

function _extends$t() { _extends$t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }

function SvgTrophySolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$t({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$s || (_path$s = /*#__PURE__*/React.createElement("path", {
    d: "M21.167 5.333h-3.611V3.944a.831.831 0 00-.834-.833H7.278a.831.831 0 00-.834.833v1.39h-3.61A.831.831 0 002 6.166V8.11c0 1.24.781 2.514 2.15 3.497 1.093.788 2.423 1.288 3.819 1.447 1.09 1.81 2.364 2.556 2.364 2.556v2.5H8.667c-1.226 0-2.223.719-2.223 1.944v.417c0 .23.188.417.417.417H17.14c.23 0 .417-.188.417-.417v-.417c0-1.225-.997-1.944-2.223-1.944h-1.666v-2.5s1.274-.746 2.364-2.556c1.4-.16 2.73-.66 3.82-1.447C21.215 10.625 22 9.35 22 8.11V6.167a.831.831 0 00-.833-.834zM5.447 9.806c-.846-.612-1.225-1.292-1.225-1.695v-.555h2.23c.034 1.131.2 2.125.444 2.993a5.598 5.598 0 01-1.448-.743zm14.33-1.695c0 .56-.614 1.254-1.225 1.695a5.62 5.62 0 01-1.451.743c.243-.868.41-1.862.444-2.993h2.233v.555z",
    fill: "#000"
  })));
}

var _path$r;

function _extends$s() { _extends$s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }

function SvgTurnbackArrowSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$s({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$r || (_path$r = /*#__PURE__*/React.createElement("path", {
    d: "M14.266 10.126h-6.63v1.995c0 .813-1.02 1.22-1.617.646L2.278 9.163a.889.889 0 010-1.29l3.74-3.604c.597-.574 1.618-.167 1.618.646v1.92h6.63c4.271 0 7.734 2.341 7.734 6.583C22 17.659 18.537 20 14.266 20H6.53c-.884 0-1.105-.666-1.105-1v-1.2c0-.96.737-1.127 1.105-1.091H14.266c2.44 0 4.42-.868 4.42-3.291 0-2.424-1.98-3.292-4.42-3.292z",
    fill: "#000"
  })));
}

var _path$q;

function _extends$r() { _extends$r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }

function SvgUnderlineSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$r({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$q || (_path$q = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 4.5h1.25v6.25A6.257 6.257 0 0012 17a6.257 6.257 0 006.25-6.25V4.5h1.25a.625.625 0 00.625-.625v-1.25A.625.625 0 0019.5 2h-5.625a.625.625 0 00-.625.625v1.25a.625.625 0 00.625.625h1.25v6.25a3.125 3.125 0 11-6.25 0V4.5h1.25a.625.625 0 00.625-.625v-1.25A.625.625 0 0010.125 2H4.5a.625.625 0 00-.625.625v1.25A.625.625 0 004.5 4.5zm15.625 15H3.875a.625.625 0 00-.625.625v1.25a.625.625 0 00.625.625h16.25a.624.624 0 00.625-.625v-1.25a.624.624 0 00-.625-.625z",
    fill: "#000"
  })));
}

var _path$p;

function _extends$q() { _extends$q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }

function SvgUndoSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$q({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$p || (_path$p = /*#__PURE__*/React.createElement("path", {
    d: "M10.42 10.903H2.476A.476.476 0 012 10.427V2.482c0-.262.213-.475.476-.475h1.903c.263 0 .476.213.476.475V5.58a9.81 9.81 0 017.383-3.256A9.811 9.811 0 0122 12.18c-.012 5.422-4.41 9.813-9.835 9.813a9.799 9.799 0 01-6.603-2.546.477.477 0 01-.018-.69l1.347-1.348a.475.475 0 01.65-.02 6.953 6.953 0 004.624 1.75 6.976 6.976 0 006.98-6.98 6.976 6.976 0 00-6.98-6.98 6.967 6.967 0 00-5.642 2.869h3.897c.263 0 .476.213.476.475v1.904a.476.476 0 01-.476.476z",
    fill: "#000"
  })));
}

var _path$o;

function _extends$p() { _extends$p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }

function SvgUpRightFromSquareSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$p({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$o || (_path$o = /*#__PURE__*/React.createElement("path", {
    d: "M17 14.5c-.69 0-1.25.56-1.25 1.25v3.75H4.5V8.25h3.75a1.25 1.25 0 100-2.5H4.5A2.5 2.5 0 002 8.25V19.5A2.5 2.5 0 004.5 22h11.25a2.5 2.5 0 002.5-2.5v-3.75c0-.691-.559-1.25-1.25-1.25zM21.063 2H15.75a1.25 1.25 0 00-.884 2.134l1.618 1.616-7.867 7.867a1.25 1.25 0 101.767 1.767L18.25 7.52l1.616 1.616c.358.357.894.462 1.363.271.466-.196.771-.653.771-1.157V2.937A.936.936 0 0021.062 2z",
    fill: "#000"
  })));
}

var _path$n;

function _extends$o() { _extends$o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }

function SvgUserAssignSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$o({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$n || (_path$n = /*#__PURE__*/React.createElement("path", {
    d: "M15 12a4 4 0 100-8 4 4 0 000 8zm2.8 1h-.522a5.445 5.445 0 01-4.556 0H12.2A4.201 4.201 0 008 17.2v1.3A1.5 1.5 0 009.5 20h11a1.5 1.5 0 001.5-1.5v-1.3c0-2.319-1.881-4.2-4.2-4.2zM2 11.459v1.08c0 .18.15.325.335.325h3.234v1.81c0 .29.36.435.572.23l2.76-2.675a.318.318 0 000-.46l-2.76-2.674c-.212-.203-.572-.06-.572.23v1.81H2.335a.33.33 0 00-.335.324z",
    fill: "#000"
  })));
}

var _g, _defs;

function _extends$n() { _extends$n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }

function SvgUserBlurSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$n({
    width: 26,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#user_blur_solid_svg__filter0_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 14a5 5 0 100-10 5 5 0 000 10zm3.5 1.25h-.652a6.808 6.808 0 01-5.696 0H9.5a5.251 5.251 0 00-5.25 5.25v1.625C4.25 23.16 5.09 24 6.125 24h13.75c1.035 0 1.875-.84 1.875-1.875V20.5a5.251 5.251 0 00-5.25-5.25z",
    fill: "#8B90A0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "user_blur_solid_svg__filter0_f",
    x: -3,
    y: -2,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur"
  })))));
}

var _path$m;

function _extends$m() { _extends$m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }

function SvgUserCogSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$m({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$m || (_path$m = /*#__PURE__*/React.createElement("path", {
    d: "M21.08 15.666c.081-.44.081-.89 0-1.331l.807-.466a.226.226 0 00.103-.266 4.69 4.69 0 00-1.038-1.794.228.228 0 00-.281-.043l-.807.465a3.668 3.668 0 00-1.153-.665v-.932c0-.106-.075-.2-.178-.222a4.717 4.717 0 00-2.069 0 .228.228 0 00-.178.222v.932c-.422.15-.813.375-1.153.665l-.807-.465a.229.229 0 00-.281.043 4.69 4.69 0 00-1.038 1.794.23.23 0 00.104.266l.806.466c-.081.44-.081.89 0 1.331l-.806.466a.226.226 0 00-.104.265c.21.675.57 1.285 1.038 1.794a.228.228 0 00.281.044l.807-.466c.34.291.731.516 1.153.666v.931c0 .107.075.2.178.222.697.157 1.406.15 2.069 0a.228.228 0 00.178-.222v-.931c.422-.15.813-.375 1.153-.666l.807.466c.09.053.21.034.281-.044a4.69 4.69 0 001.038-1.794.23.23 0 00-.103-.265l-.807-.466zm-3.578.85A1.517 1.517 0 0115.986 15a1.52 1.52 0 011.516-1.515A1.52 1.52 0 0119.017 15c0 .835-.678 1.516-1.515 1.516zM9 12a4 4 0 100-8 4 4 0 000 8zm6.288 7.079c-.072-.038-.144-.081-.213-.122l-.247.144a1.25 1.25 0 01-.612.165c-.34 0-.669-.143-.903-.393a5.7 5.7 0 01-1.257-2.176 1.222 1.222 0 01.56-1.428l.247-.144a3.197 3.197 0 010-.243l-.247-.144a1.221 1.221 0 01-.56-1.428c.028-.091.07-.182.1-.272-.118-.01-.234-.038-.356-.038h-.522a5.446 5.446 0 01-4.557 0H6.2A4.201 4.201 0 002 17.2v1.3A1.5 1.5 0 003.5 20h11.001c.316 0 .61-.1.85-.265a1.218 1.218 0 01-.062-.369v-.287z",
    fill: "#000"
  })));
}

var _path$l;

function _extends$l() { _extends$l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }

function SvgUserFriendsSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$l({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$l || (_path$l = /*#__PURE__*/React.createElement("path", {
    d: "M8 12c1.934 0 3.5-1.566 3.5-3.5S9.934 5 8 5a3.498 3.498 0 00-3.5 3.5C4.5 10.434 6.066 12 8 12zm2.4 1h-.26c-.65.313-1.371.5-2.14.5a4.933 4.933 0 01-2.14-.5H5.6A3.6 3.6 0 002 16.6v.9A1.5 1.5 0 003.5 19h9a1.5 1.5 0 001.5-1.5v-.9a3.6 3.6 0 00-3.6-3.6zm6.6-1a3 3 0 10-.002-6.002A3 3 0 0017 12zm1.5 1h-.119a4.21 4.21 0 01-1.381.25c-.488 0-.947-.1-1.381-.25H15.5c-.637 0-1.225.184-1.74.481A4.574 4.574 0 0115 16.6v1.2c0 .069-.016.134-.019.2H20.5a1.5 1.5 0 001.5-1.5c0-1.934-1.566-3.5-3.5-3.5z",
    fill: "#000"
  })));
}

var _path$k;

function _extends$k() { _extends$k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }

function SvgUserLockSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$k({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$k || (_path$k = /*#__PURE__*/React.createElement("path", {
    d: "M9 12a4 4 0 100-8 4 4 0 000 8zm3 2c.002-.334.09-.662.253-.953-.15-.016-.297-.047-.453-.047h-.522a5.44 5.44 0 01-4.556 0H6.2A4.201 4.201 0 002 17.2v1.3A1.5 1.5 0 003.5 20h8.778A1.986 1.986 0 0112 19v-5zm9-1h-1v-2.5a2.5 2.5 0 00-5 0V13h-1a1 1 0 00-1 1v5a1 1 0 001 1h7a1 1 0 001-1v-5a1 1 0 00-1-1zm-3.5 4.5a1 1 0 110-2 1 1 0 010 2zm1-4.5h-2v-2.5a1 1 0 012 0V13z",
    fill: "#000"
  })));
}

var _path$j;

function _extends$j() { _extends$j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }

function SvgUserMinusSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$j({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$j || (_path$j = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 10.5h-6c-.275 0-.5.225-.5.5v1c0 .275.225.5.5.5h6c.275 0 .5-.225.5-.5v-1c0-.275-.225-.5-.5-.5zM9 12a4 4 0 100-8 4 4 0 000 8zm2.8 1h-.522a5.445 5.445 0 01-4.556 0H6.2A4.201 4.201 0 002 17.2v1.3A1.5 1.5 0 003.5 20h11a1.5 1.5 0 001.5-1.5v-1.3c0-2.319-1.881-4.2-4.2-4.2z",
    fill: "#000"
  })));
}

var _path$i, _path2$3;

function _extends$i() { _extends$i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }

function SvgUserRotationSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$i({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$i || (_path$i = /*#__PURE__*/React.createElement("path", {
    d: "M17.371 14.881c-.18.207-.382.395-.621.534v.896c.649.09.246.204.778.337 1.597.4 2.597.969 2.597 1.602 0 1.208-3.637 2.188-8.125 2.188-4.487 0-8.125-.98-8.125-2.188 0-.844 1.777-1.574 4.375-1.94v-.895a2.499 2.499 0 01-.621-.534C4.299 15.49 2 16.768 2 18.25 2 20.321 6.477 22 12 22s10-1.679 10-3.75c0-1.226-1.573-2.312-4-2.995-.508-.143-.053-.269-.629-.374zM12 7a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm-2.5 7.5v3.75c0 .69.56 1.25 1.25 1.25h2.5c.69 0 1.25-.56 1.25-1.25V14.5c.69 0 1.25-.56 1.25-1.25V9.5c0-1.036-.84-1.875-1.875-1.875h-.46A3.406 3.406 0 0112 7.938c-.505 0-.982-.117-1.414-.313h-.461c-1.036 0-1.875.84-1.875 1.875v3.75c0 .69.56 1.25 1.25 1.25z",
    fill: "#000"
  })), _path2$3 || (_path2$3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.517 14.526l-2.433.573 1.231 2.176"
  })));
}

var _path$h;

function _extends$h() { _extends$h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }

function SvgUserSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$h({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$h || (_path$h = /*#__PURE__*/React.createElement("path", {
    d: "M12 12a5 5 0 100-10 5 5 0 000 10zm3.5 1.25h-.652a6.808 6.808 0 01-5.696 0H8.5a5.251 5.251 0 00-5.25 5.25v1.625C3.25 21.16 4.09 22 5.125 22h13.75c1.035 0 1.875-.84 1.875-1.875V18.5a5.251 5.251 0 00-5.25-5.25z",
    fill: "#000"
  })));
}

var _path$g, _path2$2;

function _extends$g() { _extends$g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }

function SvgUserVolumeMuteSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$g({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$g || (_path$g = /*#__PURE__*/React.createElement("path", {
    d: "M5.002 7.868l5.135 3.968A4.001 4.001 0 009 4a4 4 0 00-3.998 3.868zM9.019 13.5H9a5.456 5.456 0 01-2.278-.5H6.2A4.201 4.201 0 002 17.2v1.3A1.5 1.5 0 003.5 20h11c.703 0 1.294-.485 1.456-1.138L9.019 13.5zM12.078 13.336a4.478 4.478 0 01-.05-.33A4.208 4.208 0 0011.8 13h-.157l.435.336zM19.184 16.39c0 .347-.266.61-.622.61-.242 0-.437-.094-.675-.314l-1.863-1.735c-.024-.024-.057-.033-.1-.033H14.66c-.685 0-1.06-.38-1.06-1.093V12.18c0-.712.375-1.088 1.06-1.088h1.269a.154.154 0 00.1-.037l1.858-1.721c.257-.24.433-.333.67-.333.361 0 .628.281.628.628v6.762zM21.413 14.89a.466.466 0 01-.632.122c-.237-.155-.28-.432-.095-.722.243-.352.38-.812.38-1.295 0-.483-.133-.947-.38-1.294-.19-.286-.142-.567.095-.717a.46.46 0 01.633.112c.37.502.589 1.182.589 1.9 0 .717-.219 1.401-.59 1.894z",
    fill: "#000"
  })), _path2$2 || (_path2$2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.58 19.895L2.192 5.685a.5.5 0 01-.088-.702l.614-.79a.5.5 0 01.702-.088l18.386 14.21a.5.5 0 01.088.702l-.614.79a.5.5 0 01-.702.088z",
    fill: "#000"
  })));
}

var _path$f;

function _extends$f() { _extends$f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }

function SvgUserVolumeSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$f({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$f || (_path$f = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 12a4 4 0 100-8 4 4 0 000 8zm2.8 1h-.522a5.445 5.445 0 01-4.556 0H6.2A4.201 4.201 0 002 17.2v1.3A1.5 1.5 0 003.5 20h11a1.5 1.5 0 001.5-1.5v-1.3c0-.076-.002-.153-.006-.228a4.502 4.502 0 01-3.966-3.966A4.208 4.208 0 0011.8 13zm6.762 4a.602.602 0 00.622-.61V9.628A.619.619 0 0018.558 9c-.237 0-.413.094-.67.333l-1.858 1.72a.154.154 0 01-.1.038h-1.27c-.684 0-1.059.376-1.059 1.088v1.646c0 .713.375 1.093 1.06 1.093h1.264c.043 0 .076.01.1.033l1.863 1.735c.238.22.433.314.675.314zm2.22-1.988a.466.466 0 00.631-.122c.371-.493.59-1.177.59-1.895 0-.717-.219-1.397-.59-1.899a.46.46 0 00-.632-.112c-.237.15-.285.431-.095.717.247.347.38.811.38 1.294s-.137.943-.38 1.295c-.185.29-.142.567.095.722z",
    fill: "#000"
  })));
}

var _path$e;

function _extends$e() { _extends$e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }

function SvgUsersSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$e({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$e || (_path$e = /*#__PURE__*/React.createElement("path", {
    d: "M5 11c1.103 0 2-.897 2-2s-.897-2-2-2-2 .897-2 2 .897 2 2 2zm14 0c1.103 0 2-.897 2-2s-.897-2-2-2-2 .897-2 2 .897 2 2 2zm1 1h-2c-.55 0-1.047.222-1.41.581A4.571 4.571 0 0118.939 16H21c.553 0 1-.447 1-1v-1c0-1.103-.897-2-2-2zm-8 0c1.934 0 3.5-1.566 3.5-3.5S13.934 5 12 5a3.498 3.498 0 00-3.5 3.5c0 1.934 1.566 3.5 3.5 3.5zm2.4 1h-.26c-.65.313-1.371.5-2.14.5a4.933 4.933 0 01-2.14-.5H9.6A3.6 3.6 0 006 16.6v.9A1.5 1.5 0 007.5 19h9a1.5 1.5 0 001.5-1.5v-.9a3.6 3.6 0 00-3.6-3.6zm-6.99-.419A1.994 1.994 0 006 12H4c-1.103 0-2 .897-2 2v1c0 .553.447 1 1 1h2.06a4.582 4.582 0 012.35-3.419z",
    fill: "#000"
  })));
}

var _path$d;

function _extends$d() { _extends$d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }

function SvgVideoOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$d({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$d || (_path$d = /*#__PURE__*/React.createElement("path", {
    d: "M22 16.145V7.203c-.043-.734-.734-1.21-1.123-1.123-.389.086-.648.26-.648.26l-3.801 2.375v-2.03C16.428 4.957 14.613 5 14.613 5H3.814C2.13 5 2 6.685 2 6.685v9.978c0 1.598 1.814 1.685 1.814 1.685h10.843c1.684 0 1.77-1.642 1.77-1.642V14.59l3.802 2.419.648.216c1.253-.216 1.123-1.08 1.123-1.08zm-7.257.086a.433.433 0 01-.432.432H4.117a.433.433 0 01-.432-.432V7.117c0-.216.172-.432.432-.432h10.237c.216 0 .432.173.432.432v9.114h-.043zm5.572-1.08l-3.844-2.419v-1.987l3.844-2.505v6.911z",
    fill: "#000"
  })));
}

var _path$c;

function _extends$c() { _extends$c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }

function SvgVideoSlashSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$c({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$c || (_path$c = /*#__PURE__*/React.createElement("path", {
    d: "M21.806 18.316l-1.719-1.328c.481-.044.913-.428.913-.972V7.984c0-.797-.91-1.262-1.576-.806L16 9.541v4.287l-1-.772V7.494C15 6.669 14.331 6 13.506 6H5.87l-2.45-1.894a.502.502 0 00-.703.088l-.613.787a.498.498 0 00.088.7l1.14.881L15 15.582l5.579 4.312a.502.502 0 00.703-.087l.612-.791a.495.495 0 00-.087-.7zm-18.807-1.81C3 17.331 3.668 18 4.493 18h9.013c.35 0 .668-.125.925-.328L2.999 8.834v7.672z",
    fill: "#000"
  })));
}

var _path$b;

function _extends$b() { _extends$b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }

function SvgVideoSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$b || (_path$b = /*#__PURE__*/React.createElement("path", {
    d: "M13.674 5.333H3.66A1.66 1.66 0 002 6.993v10.014c0 .917.743 1.66 1.66 1.66h10.014a1.66 1.66 0 001.66-1.66V6.993a1.66 1.66 0 00-1.66-1.66zm6.576 1.31l-3.806 2.624v5.466l3.806 2.621c.736.507 1.75-.01 1.75-.896v-8.92c0-.882-1.01-1.403-1.75-.896z",
    fill: "#000"
  })));
}

var _path$a;

function _extends$a() { _extends$a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }

function SvgVolumeMediumSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$a || (_path$a = /*#__PURE__*/React.createElement("path", {
    d: "M10.681 17.272c0 .54-.413.948-.968.948-.376 0-.68-.146-1.049-.489l-2.896-2.697c-.037-.036-.089-.05-.155-.05H3.648c-1.064 0-1.648-.591-1.648-1.7v-2.558c0-1.108.584-1.691 1.648-1.691H5.62a.24.24 0 00.155-.058L8.665 6.3c.398-.372.672-.517 1.041-.517.562 0 .975.437.975.977v10.511zM17.087 16.784a.728.728 0 01-1.005.211c-.37-.219-.414-.67-.155-1.071.724-1.086 1.152-2.479 1.152-3.93 0-1.45-.42-2.85-1.152-3.929-.266-.4-.214-.853.155-1.071a.728.728 0 011.005.211c.923 1.29 1.448 3.018 1.448 4.79 0 1.77-.532 3.484-1.448 4.789zM14.146 14.94a.724.724 0 01-.982.189c-.37-.24-.436-.67-.148-1.123.377-.546.59-1.26.59-2.011 0-.751-.206-1.473-.59-2.012-.296-.445-.222-.883.148-1.116a.714.714 0 01.982.175c.577.78.916 1.837.916 2.953 0 1.115-.34 2.18-.916 2.945z",
    fill: "#000"
  })));
}

var _path$9;

function _extends$9() { _extends$9 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }

function SvgVolumeMuteSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$9 || (_path$9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 4.775L6.923 8.25H2.937A.937.937 0 002 9.187v5.625c0 .518.42.938.937.938h3.987l3.475 3.474c.588.587 1.6.175 1.6-.663V5.438c0-.838-1.013-1.25-1.6-.663zM20.032 12l1.782-1.783a.63.63 0 000-.891l-.891-.892a.63.63 0 00-.891 0l-1.783 1.783-1.783-1.783a.63.63 0 00-.891 0l-.892.892a.63.63 0 000 .891L16.467 12l-1.782 1.782a.63.63 0 000 .892l.891.891a.63.63 0 00.891 0l1.783-1.782 1.783 1.782a.63.63 0 00.891 0l.891-.891a.63.63 0 000-.891L20.033 12z",
    fill: "#D5D7DE"
  })));
}

var _path$8;

function _extends$8() { _extends$8 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }

function SvgVolumeStrongSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$8 || (_path$8 = /*#__PURE__*/React.createElement("path", {
    d: "M19 18.883c.34.219.784.124 1.02-.233C21.26 16.791 22 14.502 22 12.002c0-2.508-.761-4.782-1.98-6.648a.735.735 0 00-1.02-.24c-.362.225-.42.67-.17 1.07a10.56 10.56 0 011.722 5.818c0 2.194-.658 4.199-1.722 5.817-.25.394-.192.846.17 1.064zm-9.287-.663c.555 0 .968-.408.968-.948V6.761a.962.962 0 00-.975-.977c-.37 0-.643.146-1.042.517L5.775 8.977a.24.24 0 01-.155.058H3.648C2.584 9.035 2 9.618 2 10.726v2.559c0 1.108.584 1.698 1.648 1.698h1.965c.066 0 .118.015.155.051l2.896 2.697c.37.343.673.489 1.05.489zm6.369-1.225a.728.728 0 001.005-.211c.916-1.305 1.448-3.018 1.448-4.79 0-1.77-.525-3.498-1.448-4.789a.728.728 0 00-1.005-.211c-.37.219-.421.67-.155 1.071.731 1.08 1.152 2.479 1.152 3.93 0 1.45-.428 2.843-1.152 3.929-.259.4-.214.853.155 1.071zm-2.918-1.866a.724.724 0 00.982-.19c.577-.765.916-1.83.916-2.944 0-1.116-.34-2.173-.916-2.953a.714.714 0 00-.982-.175c-.37.234-.444.671-.148 1.116.384.54.59 1.26.59 2.012 0 .75-.213 1.465-.59 2.012-.288.452-.222.882.148 1.122z",
    fill: "#000"
  })));
}

var _path$7;

function _extends$7() { _extends$7 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

function SvgVolumeWeakSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7 || (_path$7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.681 17.272c0 .54-.413.948-.968.948-.376 0-.68-.146-1.049-.489l-2.896-2.697c-.037-.036-.089-.05-.155-.05H3.648c-1.064 0-1.648-.591-1.648-1.7v-2.558c0-1.108.584-1.691 1.648-1.691H5.62a.24.24 0 00.155-.058L8.665 6.3c.398-.372.672-.517 1.041-.517.562 0 .975.437.975.977v10.511zM14.146 14.94a.724.724 0 01-.982.189c-.37-.24-.436-.67-.148-1.123.377-.546.59-1.26.59-2.011 0-.751-.206-1.473-.59-2.012-.296-.445-.222-.883.148-1.116a.714.714 0 01.982.175c.577.78.916 1.837.916 2.953 0 1.115-.34 2.18-.916 2.945z",
    fill: "#000"
  })));
}

var _path$6, _path2$1;

function _extends$6() { _extends$6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }

function SvgWalkieTalkie(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6 || (_path$6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 2.84A.84.84 0 017.84 2h.32a.84.84 0 010 1.68h-.32A.84.84 0 017 2.84z",
    fill: "#000"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 5.297a1 1 0 112 0V7h7a2 2 0 012 2v11a2 2 0 01-2 2H8a2 2 0 01-2-2V9a2 2 0 011-1.732V5.297zM9 9a1 1 0 00-1 1v3a1 1 0 001 1h6a1 1 0 001-1v-3a1 1 0 00-1-1H9zm-1.01 7.3a.3.3 0 01.3-.3h7.4a.3.3 0 110 .6h-7.4a.3.3 0 01-.3-.3zm.3 1.366a.3.3 0 100 .6h7.4a.3.3 0 100-.6h-7.4zm-.3 1.967a.3.3 0 01.3-.3h7.4a.3.3 0 110 .6h-7.4a.3.3 0 01-.3-.3z",
    fill: "#000"
  })));
}

var _path$5;

function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

function SvgWifiSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5 || (_path$5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.32 11.108c.164.182.43.173.603-.019 2.13-2.258 4.937-3.447 8.073-3.447 3.164 0 5.98 1.198 8.1 3.456.165.174.421.174.586-.009l1.198-1.207c.155-.155.155-.356.027-.52C19.86 6.837 16.01 5 11.997 5 7.981 5 4.132 6.838 2.084 9.361c-.119.165-.119.366.037.521l1.197 1.226zm3.602 3.602c.192.192.439.164.621-.028 1.043-1.16 2.734-1.984 4.462-1.974 1.737-.01 3.429.84 4.49 1.993.164.192.402.192.585 0l1.353-1.326c.146-.146.164-.347.027-.512-1.316-1.61-3.758-2.798-6.455-2.798-2.706 0-5.138 1.189-6.464 2.798-.137.165-.119.348.028.512l1.353 1.335zm5.083 4.736c.192 0 .366-.082.704-.42l2.112-2.03a.37.37 0 00.055-.503c-.585-.74-1.655-1.372-2.87-1.372-1.253 0-2.332.659-2.908 1.427-.092.146-.055.31.082.448l2.112 2.03c.338.329.512.42.713.42z",
    fill: "#000"
  })));
}

var _path$4;

function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

function SvgWifiWeakSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4 || (_path$4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.013 15.153c.502 0 .84-.33.85-.85.027-3.072.064-6.354.091-9.389 0-.54-.43-.914-.95-.914-.53 0-.951.375-.951.914.027 3.035.073 6.317.1 9.389.019.52.348.85.86.85zM9.763 5.124c-3.144.54-5.987 2.103-7.678 4.178a.384.384 0 00.036.521l1.198 1.225a.4.4 0 00.603-.018C5.54 9.31 7.561 8.223 9.8 7.812l-.036-2.688zm4.462.01l-.027 2.678c2.24.393 4.241 1.508 5.896 3.227.164.174.411.165.585-.01l1.197-1.206c.165-.155.156-.365.028-.52-1.71-2.058-4.507-3.667-7.68-4.17zm-.046 5.146l-.036 2.807a6.113 6.113 0 012.349 1.554c.174.183.402.174.594-.01l1.335-1.316c.155-.155.164-.356.036-.512-.96-1.152-2.495-2.12-4.278-2.523zm-4.351 0c-1.783.43-3.31 1.344-4.288 2.523-.128.156-.128.348.037.512l1.344 1.335c.192.192.439.165.621-.037a5.993 5.993 0 012.322-1.545l-.036-2.788zm2.176 9.124a1.38 1.38 0 001.38-1.38c0-.76-.613-1.372-1.38-1.372-.76 0-1.38.612-1.38 1.371s.62 1.38 1.38 1.38z",
    fill: "#000"
  })));
}

var _path$3, _path2;

function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

function SvgWriteTestOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.427 3.624s.22-.44-.22-.44H3.767s-1.76-.11-1.76 1.54v14.19s-.22 1.76 1.98 1.76h14.96s1.54-.11 1.54-1.76v-7.92s-.11-.55-.55 0l-.88.88s-.11 0-.11.55v6.71H3.657v-14.3h10.23s.22 0 .44-.22l1.1-.99z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.477 5.164l-1.32-1.32c-1.65-1.76-3.08-.22-3.08-.22l-9.13 9.02-.44 3.19c.11 1.76 1.65 1.54 1.65 1.54l3.08-.33 9.35-9.35c.99-1.54-.11-2.53-.11-2.53zm-10.01 10.34l-2.31.22.22-2.31 6.49-6.49 1.98 1.98-6.38 6.6zm8.8-8.69l-1.1 1.1-2.09-2.09.99-.99c.33-.33.66-.11.66-.11l1.32 1.32c.44.44.22.77.22.77zM11.246 7.474s.22-.44-.22-.44h-5.5c-.22 0-.33.11-.33.33v1.1c0 .22.11.33.33.33h4.18s.22 0 .44-.22l1.1-1.1zM14.216 16.494s-.22.44.22.44h2.97c.22 0 .33-.11.33-.33v-.99c0-.22-.11-.33-.33-.33h-.55s-1.32 0-1.54.22l-1.1.99zM6.956 15.724s.11-.44-.22-.44h-1.21c-.22 0-.33.11-.33.33v.99c0 .22.11.33.33.33h.88s.44 0 .44-.22l.11-.99zM8.276 11.654s.22-.44-.22-.44h-2.53c-.22 0-.33.11-.33.33v.99c0 .11.22.33.33.33h1.21s.22 0 .44-.22l1.1-.99z",
    fill: "#000"
  })));
}

var _path$2;

function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

function SvgXmarkCircleSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.005 21.99c5.467 0 9.995-4.528 9.995-9.995S17.462 2 11.995 2C6.528 2 2 6.528 2 11.995s4.538 9.995 10.005 9.995zm-3.404-5.735a.848.848 0 01-.845-.867c0-.216.082-.433.247-.588l2.795-2.795L8.003 9.21a.787.787 0 01-.247-.588c0-.474.37-.836.845-.836.238 0 .434.073.588.238l2.806 2.795 2.816-2.806a.803.803 0 01.598-.247.84.84 0 01.846.835c0 .238-.083.423-.248.609l-2.805 2.795 2.795 2.785a.87.87 0 01.247.598.856.856 0 01-.856.867.885.885 0 01-.608-.258l-2.785-2.795-2.775 2.795a.866.866 0 01-.619.258z",
    fill: "#000"
  })));
}

var _path$1;

function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

function SvgXmarkOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
    d: "M2.353 19.91c-.464.464-.477 1.273 0 1.737.477.464 1.273.464 1.737 0l7.917-7.916 7.903 7.916c.477.464 1.273.477 1.737 0 .464-.477.464-1.273 0-1.737l-7.916-7.917 7.916-7.903c.464-.477.477-1.273 0-1.737a1.258 1.258 0 00-1.737 0l-7.903 7.917L4.09 2.353c-.464-.464-1.273-.477-1.737 0-.464.477-.464 1.273 0 1.724l7.917 7.916-7.917 7.917z",
    fill: "#000"
  })));
}

var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgZoomSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.74 19.288l-3.908-3.903c-.196-.156-.43-.273-.665-.273h-.625a8.128 8.128 0 001.72-4.995C18.262 5.668 14.587 2 10.13 2 5.635 2 2 5.668 2 10.117c0 4.488 3.635 8.117 8.13 8.117a8.088 8.088 0 005.004-1.717v.663c0 .235.079.469.274.664l3.87 3.863c.391.39.977.39 1.33 0l1.094-1.092c.39-.352.39-.937.039-1.327zm-11.61-4.176a4.984 4.984 0 01-5.003-4.995 5.009 5.009 0 015.004-4.995c2.736 0 5.003 2.263 5.003 4.995 0 2.77-2.267 4.995-5.003 4.995z",
    fill: "#000"
  })));
}

var SVG = /*#__PURE__*/Object.freeze({
  __proto__: null,
  OnlinetestSolid: SvgOnlinetestSolid,
  AddressBookSolid: SvgAddressBookSolid,
  AddressCardSolid: SvgAddressCardSolid,
  AlbumSolid: SvgAlbumSolid,
  AngleLeftSolid: SvgAngleLeftSolid,
  AngleRightSolid: SvgAngleRightSolid,
  ArrowLeftOutline: SvgArrowLeftOutline,
  ArrowRightOutline: SvgArrowRightOutline,
  ArrowSquareUpSolid: SvgArrowSquareUpSolid,
  BackToListSolid: SvgBackToListSolid,
  BackstageManagementSolid: SvgBackstageManagementSolid,
  BanSolid: SvgBanSolid,
  BanSolidGray: SvgBanSolidGray,
  BarsSolid: SvgBarsSolid,
  BoldSolid: SvgBoldSolid,
  BookReaderSolid: SvgBookReaderSolid,
  BookSolid: SvgBookSolid,
  BookmarkSolid: SvgBookmarkSolid,
  BooksSolid: SvgBooksSolid,
  BoxOpenSolid: SvgBoxOpenSolid,
  BrowserSolid: SvgBrowserSolid,
  BullhornSolid: SvgBullhornSolid,
  CalenderTodaySolid: SvgCalenderTodaySolid,
  CameraSolid: SvgCameraSolid,
  CaretDownSolid: SvgCaretDownSolid,
  CaretLeftSolid: SvgCaretLeftSolid,
  CaretRightSolid: SvgCaretRightSolid,
  CaretUpSolid: SvgCaretUpSolid,
  ChalkboardOutline: SvgChalkboardOutline,
  ChalkboardSlashSolid: SvgChalkboardSlashSolid,
  ChalkboardSolid: SvgChalkboardSolid,
  CheckCircleSolid: SvgCheckCircleSolid,
  CheckSolid: SvgCheckSolid,
  ChevronDownOutline: SvgChevronDownOutline,
  ChevronDownToBottomSolid: SvgChevronDownToBottomSolid,
  ChevronLeftOutline: SvgChevronLeftOutline,
  ChevronRightOutline: SvgChevronRightOutline,
  ChevronUpOutline: SvgChevronUpOutline,
  ChevronUpToTopSolid: SvgChevronUpToTopSolid,
  CircleOutline: SvgCircleOutline,
  ClassSolid: SvgClassSolid,
  CloseSquareSolid: SvgCloseSquareSolid,
  CogSolid: SvgCogSolid,
  CommentAltOutline: SvgCommentAltOutline,
  CommentAltSolid: SvgCommentAltSolid,
  CommentSlashSolid: SvgCommentSlashSolid,
  CommentSmileSolid: SvgCommentSmileSolid,
  CommentSolid: SvgCommentSolid,
  Comments: SvgComments,
  CommentsSolid: SvgCommentsSolid,
  CopySolid: SvgCopySolid,
  CurveSolid: SvgCurveSolid,
  Earphone: SvgEarphone,
  EarphoneBluetooth: SvgEarphoneBluetooth,
  EditSolid: SvgEditSolid,
  EllipsisVMediumSolid: SvgEllipsisVMediumSolid,
  EnvelopeOpenTextSolid: SvgEnvelopeOpenTextSolid,
  EquilateralTriangleOutline: SvgEquilateralTriangleOutline,
  EraserSolid: SvgEraserSolid,
  ExclamationCircleSolid: SvgExclamationCircleSolid,
  ExpandSolid: SvgExpandSolid,
  EyeSlashSolid: SvgEyeSlashSolid,
  EyeSolid: SvgEyeSolid,
  FileAddSolid: SvgFileAddSolid,
  FileAltSolid: SvgFileAltSolid,
  FilmSolid: SvgFilmSolid,
  FluentLiveFilled: SvgFluentLiveFilled,
  FluentLiveOffFilled: SvgFluentLiveOffFilled,
  FolderOpenSolid: SvgFolderOpenSolid,
  GiftSolid: SvgGiftSolid,
  GlobeSolid: SvgGlobeSolid,
  HandPaperSolid: SvgHandPaperSolid,
  HeadphonesAltSolid: SvgHeadphonesAltSolid,
  HeadsetSolid: SvgHeadsetSolid,
  HistorySolid: SvgHistorySolid,
  HomeworkSolid: SvgHomeworkSolid,
  HorizontalOneColumnsOutline: SvgHorizontalOneColumnsOutline,
  HorizontalTwoColumnsAOutline: SvgHorizontalTwoColumnsAOutline,
  HorizontalTwoColumnsBOutline: SvgHorizontalTwoColumnsBOutline,
  Image: SvgImage,
  ImageOutline: SvgImageOutline,
  ImageSolid: SvgImageSolid,
  InfoSolid: SvgInfoSolid,
  IntroductionSolid: SvgIntroductionSolid,
  ItalicSolid: SvgItalicSolid,
  LightRefresh: SvgLightRefresh,
  LightbulbSolid: SvgLightbulbSolid,
  LineSolid: SvgLineSolid,
  LockOpenSolid: SvgLockOpenSolid,
  LockSolid: SvgLockSolid,
  LongArrowRightSolid: SvgLongArrowRightSolid,
  MarkerSolid: SvgMarkerSolid,
  MarkerpenSolid: SvgMarkerpenSolid,
  MedalSolid: SvgMedalSolid,
  MegaphoneSolid: SvgMegaphoneSolid,
  MicrophoneAltSlashSolid: SvgMicrophoneAltSlashSolid,
  MicrophoneAltSolid: SvgMicrophoneAltSolid,
  MinusSolid: SvgMinusSolid,
  MoreOutline: SvgMoreOutline,
  MousePointerSolid: SvgMousePointerSolid,
  MusicSolid: SvgMusicSolid,
  OrignalsizeSolid: SvgOrignalsizeSolid,
  PaperPlaneSolid: SvgPaperPlaneSolid,
  PaperclipSolid: SvgPaperclipSolid,
  PenSolid: SvgPenSolid,
  PeopleArrowsSolid: SvgPeopleArrowsSolid,
  PhotoVideoSolid: SvgPhotoVideoSolid,
  PlaySolid: SvgPlaySolid,
  PlusCircleSolid: SvgPlusCircleSolid,
  PlusOutline: SvgPlusOutline,
  PlusSolid: SvgPlusSolid,
  QaToolSolid: SvgQaToolSolid,
  QuestionCircleOutline: SvgQuestionCircleOutline,
  RaisehandSolid: SvgRaisehandSolid,
  RaisehandSyncSolid: SvgRaisehandSyncSolid,
  RandomSolid: SvgRandomSolid,
  RecordSolid: SvgRecordSolid,
  RedoSolid: SvgRedoSolid,
  ReturnOutline: SvgReturnOutline,
  RightTriangleOutline: SvgRightTriangleOutline,
  SchoolSolid: SvgSchoolSolid,
  ScoreSolid: SvgScoreSolid,
  Screen: SvgScreen,
  SelectSolid: SvgSelectSolid,
  ShapesSolid: SvgShapesSolid,
  ShareSquareSolid: SvgShareSquareSolid,
  ShoePrintsSolid: SvgShoePrintsSolid,
  SignOutSolid: SvgSignOutSolid,
  SignalBadSolid: SvgSignalBadSolid,
  SignalGoodSolid: SvgSignalGoodSolid,
  SlotsSolid: SvgSlotsSolid,
  SmileOutline: SvgSmileOutline,
  SmileSolid: SvgSmileSolid,
  Speaker: SvgSpeaker,
  SpeakerBluetooth: SvgSpeakerBluetooth,
  SpeakingNoneSolid: SvgSpeakingNoneSolid,
  SpeakingStrongSolid: SvgSpeakingStrongSolid,
  SpeakingWeakSolid: SvgSpeakingWeakSolid,
  SquareOutline: SvgSquareOutline,
  StarOutline: SvgStarOutline,
  StarSolid: SvgStarSolid,
  StickynoteOutline: SvgStickynoteOutline,
  StopCircleSolid: SvgStopCircleSolid,
  StopRecordSolid: SvgStopRecordSolid,
  StopwatchSolid: SvgStopwatchSolid,
  StraightOneColumnsOutline: SvgStraightOneColumnsOutline,
  StraightTwoColumnsOutline: SvgStraightTwoColumnsOutline,
  TabletAltSolid: SvgTabletAltSolid,
  TextSolid: SvgTextSolid,
  ThSolid: SvgThSolid,
  ThumbsUpOutline: SvgThumbsUpOutline,
  ThumbsUpSolid: SvgThumbsUpSolid,
  ThumbtackSolid: SvgThumbtackSolid,
  ToolboxSolid: SvgToolboxSolid,
  TrashSolid: SvgTrashSolid,
  TrophySolid: SvgTrophySolid,
  TurnbackArrowSolid: SvgTurnbackArrowSolid,
  UnderlineSolid: SvgUnderlineSolid,
  UndoSolid: SvgUndoSolid,
  UpRightFromSquareSolid: SvgUpRightFromSquareSolid,
  UserAssignSolid: SvgUserAssignSolid,
  UserBlurSolid: SvgUserBlurSolid,
  UserCogSolid: SvgUserCogSolid,
  UserFriendsSolid: SvgUserFriendsSolid,
  UserLockSolid: SvgUserLockSolid,
  UserMinusSolid: SvgUserMinusSolid,
  UserRotationSolid: SvgUserRotationSolid,
  UserSolid: SvgUserSolid,
  UserVolumeMuteSolid: SvgUserVolumeMuteSolid,
  UserVolumeSolid: SvgUserVolumeSolid,
  UsersSolid: SvgUsersSolid,
  VideoOutline: SvgVideoOutline,
  VideoSlashSolid: SvgVideoSlashSolid,
  VideoSolid: SvgVideoSolid,
  VolumeMediumSolid: SvgVolumeMediumSolid,
  VolumeMuteSolid: SvgVolumeMuteSolid,
  VolumeStrongSolid: SvgVolumeStrongSolid,
  VolumeWeakSolid: SvgVolumeWeakSolid,
  WalkieTalkie: SvgWalkieTalkie,
  WifiSolid: SvgWifiSolid,
  WifiWeakSolid: SvgWifiWeakSolid,
  WriteTestOutline: SvgWriteTestOutline,
  XmarkCircleSolid: SvgXmarkCircleSolid,
  XmarkOutline: SvgXmarkOutline,
  ZoomSolid: SvgZoomSolid
});

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject;
var sizes = [8, 12, 16, 20, 24, 28, 32, 36];
var sizeMap = {
  xxxs: sizes[0],
  xxs: sizes[1],
  xs: sizes[2],
  sm: sizes[3],
  md: sizes[4],
  lg: sizes[5],
  xl: sizes[6],
  xxl: sizes[7]
};
var defaultSize = sizeMap.md;

var calcSize = size => {
  if (Array.isArray(size)) {
    return size.map(item => sizeMap[item]);
  }

  return sizeMap[size] || defaultSize;
};

var StyledIcon = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  ", "\n  color: ", ";\n  cursor: ", ";\n  > svg {\n    width: 100%;\n    height: 100%;\n    color: currentColor;\n    * {\n      fill: currentColor;\n      transform: scale(", ");\n    }\n  }\n"])), layout, _ref => {
  var {
    color
  } = _ref;
  return color || 'currentColor';
}, _ref2 => {
  var {
    onClick
  } = _ref2;
  return onClick ? 'pointer' : 'inherit';
}, _ref3 => {
  var {
    width
  } = _ref3;
  return width / defaultSize;
});

function Icon(_ref4, ref) {
  var {
    name,
    className,
    size = defaultSize,
    width,
    color,
    onClick
  } = _ref4;
  var SVGComponent = useMemo(() => SVG[name], [name]);
  return /*#__PURE__*/React__default.createElement(StyledIcon, {
    ref: ref,
    className: className,
    width: width || calcSize(size),
    height: width || calcSize(size),
    color: color,
    onClick: onClick
  }, SVGComponent ? /*#__PURE__*/React__default.createElement(SVGComponent, null) : null);
}

var Icon$1 = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(Icon));

export { SVG, Icon$1 as default };
//# sourceMappingURL=icon.esm.js.map
